<template>
  <div>
    <div class="mapdiv" v-if="isMapVisible &&tk&&mkList.length>0">
      <pl-lazy>
        <main-map
            ref="mainmap"
            :lyrdata="lyrdata"
            :mapCtrlTools="mapCtrlTools4Use"
            :mapParams="mapParams"
            :showSearchBar="false"
        >
        </main-map>

      </pl-lazy>
    </div>
    <div class="bak" v-if="showBak"></div>

    <!-- 其他DOM -->
    <div class="laboratoryLogo">
      <div class="mark"></div>
      <!--顶部导航栏-->
      <div :class="showMyLayersAndVectorPanel==true ? 'tabsNavi' : 'tabsNavi-s'">

        <SearchBar></SearchBar>
        <div class="tabsNaviClose" @click="$router.push('/rsManage')">关闭</div>
      </div>
      <!--左侧导航栏-->
      <div class="layersAndVectorsPanel" v-if="showMyLayersAndVectorPanel&&!showTipPanel">
        <div class="tabs">
          吉林一号图源
        </div>
        <div class="tabPanels">
          <div v-if="myLayersPanelShow" class="layersPanel">
            <!-- 查找我的图源 -->
            <!-- 购买企业版展示 -->
            <div style="width: 10px;height: 25px;"></div>
            <!--影像分割展示-->
            <div v-for="(item,index) in splitImageList" :key="'dir_name'+item.dir_name">
              <div :class="tabBlock2Select[index]==true ? 'tabPanelsBlock1-s' : 'tabPanelsBlock1'">
                <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/文件夹收回.png" alt="" class="tabBlock1Select" style="left: 15px;top: 16px;" v-if="tabBlock2Select[index]==false" @click="fileOpen(index,1,item)">
                <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/文件夹打开.png" alt="" class="tabBlock1Select" style="top: 20px;" v-if="tabBlock2Select[index]==true" @click="fileOpen(index,0,item)">
                <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/边框.png" alt="" style="position:absolute;left: 41px;top: 5px;">
                <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/蓝色文件夹默认.png" alt="" style="position:absolute;left: 52px;top: 18px;" v-if="!tabBlock2Select[index]">
                <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/蓝色文件夹打开.png" alt="" style="position:absolute;left: 49px;top: 18px;" v-if="tabBlock2Select[index]">
                <div class="tabBlock1Text1" style="top: 15px;">{{ item.dir_name }}</div>
              </div>
              <div v-for="(img, index1) in item.list" :key="'mk'+index1">
                <div :class="tabBlock2Select[index]==true ? 'tabPanelsBlock1-s' : 'tabPanelsBlock1'" v-if="tabBlock2Select[index]==true">
                  <img v-if="img.program_id!=selectedImgSectionId" @click="chooseImgSection(img)" src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/单选未选中.png" alt="" class="tabBlock1Select"  style="left:35px">
                  <img v-if="img.program_id==selectedImgSectionId" src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/单选选中.png" alt="" class="tabBlock1Select"  style="left:35px">
                  <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/文本编辑.png" height="40" width="35" style="position:absolute;left: 72px;top: 8px;" />
                  <img @click="editImgSection(img)" src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/边框.png" alt="" style="position:absolute;left: 67px;top: 5px;">
                  <div class="tabBlock1Text1" style="left:118px">{{ img.name }}<span v-if="img.end_time<getTodayTime()" style="color:red;">【已过期】</span><span v-if="img.start_time>getTodayTime()" style="color:red;">【尚未到期】</span></div>
                  <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/创建日期icon.png" alt="" style="position:absolute;left: 118px;top:34px;">
                  <div class="tabBlock1Text2" style="left:137px;width: 100px;">{{img.start_time.split(" ")[0]}}</div>
                  <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/创建日期icon.png" alt="" style="position:absolute;left: 227px;top:34px;">
                  <div class="tabBlock1Text2" style="left:247px;width: 100px;">{{img.end_time.split(" ")[0]}}</div>
                  <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/插入链接.png" height="11" width="12" style="position:absolute;left: 335px;top:34px;" />
                  <div class="tabBlock1Text2" style="left:351px;width: 100px;cursor:pointer;color:#96b4ff;" @click="clickServiceLink(img)">服务链接</div>
                </div>
              </div>
            </div>
            <div @click="clickCreateImgSeparate()" class="createImgSeparateCtn">
              <img src="../assets/rsTool/创建按钮.png" height="22" width="22" style="display: inline-block;margin-right: 5px;" />
              创建影像拆分
            </div>

          </div>
          <div v-else class="layersPanel">
            <!-- <div v-for="vec in tableData" :key="mk.name" class="vectorLi"> -->
            <a-checkbox-group v-model="checkBoxVectorObj.checkedList" name="checkboxgroup" @change="onVectorChangeOption" >
              <!-- <perfect-scrollbar> -->

              <div v-for="(vec,index) in tableData" :key="'table'+index" class="layersLi vectorLi">
                <div>
                  <a-checkbox :value="vec.name"></a-checkbox>
                </div>
                <div class="thumbImg">
                  <img v-if="/Point/i.test(vec.shape_type)" src="../assets/Laboratory/点.png"/>
                  <img v-if="/Line/i.test(vec.shape_type)" src="../assets/Laboratory/线.png"/>
                  <img v-if="/Polygon/i.test(vec.shape_type)" src="../assets/Laboratory/面.png"/>
                </div>
                <div class="mkInfo">
                  <div>{{vec.name}}</div>
                  <div><img src="../assets/Laboratory/发布时间.png"/> {{ vec.create_time }}</div>
                </div>

              </div>
              <!-- </perfect-scrollbar> -->

            </a-checkbox-group>
            <!-- </div> -->
          </div>

        </div>
      </div>
      <div class="closePanelImg" @click="showMyLayersAndVectorPanel=true"></div>

    </div>
    <!--分享链接对话框-->
    <a-modal v-model="shareLinkModal"
             centered
             width="690"
             >
      <div style="display:flex;justify-content:left;width:690px;height:auto;min-height:100px;margin-top: 35px;">
        <div style="width:63px;height: 63px;margin-top: 15px;">
          <img src="../assets/userCenter/我的项目-分享管理.png" height="63" width="63"/>
        </div>
        <div class="shareListCtn">
            <span v-for="(item,i) in shareList" :key="i">
                <span style="font-weight: bold">
                  图层“{{ item.name }}”,服务链接：</span><br/>
                {{ item.url }}<br/><br/>
            </span>
        </div>
      </div>
      <template slot="footer">
        <a-button @click="exportShareList" type="primary">
          全部导出
        </a-button>
        <a-button @click="shareLinkModal=false">
          关闭
        </a-button>
      </template>
    </a-modal>

    <!--影像拆分弹窗-->
    <div v-if="imgSeparateDialog" class="shadow-imgSeparate">
      <div class="createImgSeparateDialog">
        <div class="i-titleCtn">
          <img src="../assets/rsTool/卫星.png" height="20" width="20" style="margin-right: 5px;"/>
          影像拆分
          <img src="../assets/rsTool/关闭.png" @click="closeImgSeparate()" height="20" width="20" style="position:absolute;top: 15px;right: 15px;cursor:pointer;" />
        </div>
        <div class="i-middleCtn">
          <div class="createProjectLine">
            <div class="item-name">
              影像名称
              <img src="../assets/userCenter/必填标志.png" style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>

            </div>
            <div class="item-input">
              <a-input v-model="addProjectData.name"
                       size="large" style="height: 40px;font-size: 14px;" placeholder="请填写影像名称"/>
            </div>
          </div>
          <div class="createProjectLine">
            <div class="item-name">
              影像描述
            </div>
            <div class="item-input">
              <a-textarea v-model="addProjectData.description"
                          size="large" style="height: 60px;font-size: 14px" placeholder="请填写影像描述"/>
            </div>
          </div>
          <div class="createProjectLine">
            <div class="item-name">
              影像有效期
              <img src="../assets/userCenter/必填标志.png"
                   style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
            </div>
            <div class="item-input">
              <a-range-picker
                  :key="'rangePicker'+getNowTime"
                  :placeholder="['开始日期','结束日期']"
                  size="large"
                  :locale="locale"
                  style="height:40px;width: 560px;font-size: 14px;"
                  :disabled-date="disabledDate"
                  @calendarChange="rangePickerChange"
                  v-model="tempTime"
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD">
              </a-range-picker>
            </div>
          </div>
          <div class="createProjectLine">
            <div class="item-name">
              选择图源
              <img src="../assets/userCenter/必填标志.png"
                   style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
            </div>
            <div class="item-input split-source-row">
              <a-select
                  v-model="splitSourceCategory"
                  :placeholder="'选择图源分类'"
                  style="width: 220px;margin-right: 10px;height:40px;font-size: 14px;"
                  dropdownClassName="img-split-mk-dropdown"
                  @change="onSplitSourceCategoryChange">
                <a-select-option value="basic">基础图源</a-select-option>
                <a-select-option value="premium">高级图源</a-select-option>
              </a-select>
              <div class="split-mk-name-wrap">
                <a-select
                    labelInValue
                    :value="splitMkValue"
                    :placeholder="'选择图源名称'"
                    :disabled="!splitSourceCategory || splitMkSeriesLoading"
                    :loading="splitMkSeriesLoading"
                    style="width: 330px;height:40px;font-size: 14px;"
                    dropdownClassName="img-split-mk-dropdown img-split-mk-series-dropdown"
                    @change="onSplitMkValueChange">
                  <a-select-option v-for="item in splitMkSeriesFlat" :key="item.id" :value="item.id">
                    <span class="split-mk-opt-row">
                      <span class="split-mk-opt-name">
                        {{ item.name }}
                      </span>
                      <span
                          v-if="item.hasBinding"
                          class="split-mk-opt-arrow"
                          role="button"
                          tabindex="-1"
                          title="展开子图源"
                          @mousedown.stop.prevent="openSplitMkDetail(item, $event)"
                          @mouseup.stop.prevent="onSplitMkArrowStopSelect"
                          @click.stop.prevent="onSplitMkArrowStopSelect">
                      </span>
                    </span>
                  </a-select-option>
                </a-select>
                <div
                    v-show="splitDetailVisible"
                    ref="splitMkDetailPanel"
                    class="split-mk-detail-panel"
                    :style="splitDetailPanelStyle"
                    @mousedown.stop>
                  <div v-if="splitDetailLoading" class="split-mk-detail-loading">加载中…</div>
                  <template v-else>
                    <div
                        v-for="row in splitDetailFlatRows"
                        :key="row.key"
                        :class="['split-mk-detail-row', { 'is-child': row.isChild }]"
                        @click="onPickSplitDetailRow(row)">
                      {{ row.name }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="createProjectLine">
            <div class="item-name">
              选择矢量
              <img src="../assets/userCenter/必填标志.png"
                   style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
            </div>
            <div class="item-input">
              <div class="vectorCtn">
                <div style="width: 240px;height: 40px;line-height: 40px;text-align: center;font-size: 16px;border-bottom: 1px solid #979797;">
                  在矢量库中选择（仅面状矢量）
                </div>
                <div class="vectorListCtn">
                  <a-checkbox-group v-model="addProjectData.shape_ids" style="width: 100%">
                    <div v-for="item in vectorList" :key="item.id" class="itemCtn">
                      <a-checkbox style="color:#979797" :value="item.id" :disabled="Number(item.nrings)>16">
                        {{ item.name }}
                      </a-checkbox>
                      <a-tag color="black" style="float:right;margin-top: 5px;cursor: pointer" @click="checkAndShow(item.id)">
                        查看
                      </a-tag>
                    </div>
                  </a-checkbox-group>
                </div>
              </div>
              <div style="width: 120px;height:0px;margin-top: 5px;border-bottom: 1px solid #979797;">
              </div>
              <div @click="createVector()" style="width: 100%;height: 20px;line-height: 20px;font-size: 14px;color: #979797;cursor:pointer">
                <img src="../assets/rsTool/创建按钮.png" height="16" width="16" style="display: inline-block;margin-right: 9px;" /> 创建矢量
              </div>
            </div>
          </div>
        </div>
        <div class="i-bottomCtn" style="margin-top: 10px;">
          <div @click="clickCreateSplit" class="i-button" style="margin-right: 30px;">
            确定
          </div>
          <div @click="imgSeparateDialog=false" class="i-button">
            取消
          </div>
        </div>
      </div>
    </div>
    <!--编辑影像拆分弹窗-->
    <div v-if="editImgSeparateDialog" class="shadow-imgSeparate">
      <div class="createImgSeparateDialog">
        <div class="i-titleCtn">
          <img src="../assets/rsTool/卫星.png" height="20" width="20" style="margin-right: 5px;"/>
          编辑影像拆分
          <img src="../assets/rsTool/关闭.png" @click="closeEditImgSection()" height="20" width="20" style="position:absolute;top: 15px;right: 15px;cursor:pointer;" />
        </div>
        <div class="i-middleCtn">
          <div class="createProjectLine">
            <div class="item-name">
              影像名称
              <img src="../assets/userCenter/必填标志.png" style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>

            </div>
            <div class="item-input">
              <a-input v-model="editImgSeparateObj.name"
                       size="large" style="height: 40px;font-size: 14px;" placeholder="请填写影像名称"/>
            </div>
          </div>
          <div class="createProjectLine">
            <div class="item-name">
              影像描述
            </div>
            <div class="item-input">
              <a-textarea v-model="editImgSeparateObj.description"
                          size="large" style="height: 60px;font-size: 14px" placeholder="请填写影像描述"/>
            </div>
          </div>
          <div class="createProjectLine">
            <div class="item-name">
              影像有效期
              <img src="../assets/userCenter/必填标志.png"
                   style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
            </div>
            <div class="item-input">
              <a-range-picker
                  :key="'rangePicker'+getNowTime"
                  :placeholder="['开始日期','结束日期']"
                  size="large"
                  :locale="locale"
                  style="height:40px;width: 560px;font-size: 14px;"
                  :disabled-date="disabledDate"
                  @calendarChange="rangePickerChange"
                  v-model="tempTime"
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD">
              </a-range-picker>
            </div>
          </div>
          <!-- <div class="createProjectLine">
            <div class="item-name">
              选择图源
              <img src="../assets/userCenter/必填标志.png"
                   style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
            </div>
            <div class="item-input">
              <div style="width:100%;height:40px;line-height:40px;font-size: 14px;border:solid 1px #d9d9d9;border-radius: 5px;color:#b9b9b9;padding-left: 10px;">
                {{editImgSeparateObj.repository_name}}
              </div>
            </div>
          </div> -->

          <div class="createProjectLine">
            <div class="item-name">
              选择矢量
              <img src="../assets/userCenter/必填标志.png"
                   style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
            </div>
            <div class="item-input">
              <div class="vectorCtn">
                <div style="width: 240px;height: 40px;line-height: 40px;text-align: center;font-size: 16px;border-bottom: 1px solid #979797;">
                  在矢量库中选择（仅面状矢量）
                </div>
                <div class="vectorListCtn" style="height:130px;">
                  <a-checkbox-group :disabled="true" v-model="editImgSeparateObj.shape_ids" style="width: 100%">
                    <div v-for="item in vectorList" :key="item.id" class="itemCtn">
                      <a-checkbox style="color:#979797" :value="item.id" :disabled="Number(item.nrings)>16">
                        {{ item.name }}
                      </a-checkbox>
                    </div>
                  </a-checkbox-group>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="i-bottomCtn" >
          <div @click="clickSubmitEditProject" class="i-button" style="margin-right: 30px;">
            确定
          </div>
          <div @click="closeEditImgSection()" class="i-button">
            取消
          </div>
        </div>
      </div>
    </div>
    <!--创建矢量对话框-->
    <a-modal v-model="createVectorModal"
             centered width="1330px" :header="null"
             :footer="null"
    >
      <div class="createVectorTitle">
        <span style="float:left">创建新矢量</span>
        <div style="width: 500px;height: 40px;line-height: 40px;font-size: 14px;color: #ffffff;float:left;margin-left:400px;">
          当前时间：{{nowTime}}
        </div>
      </div>
      <div class="createVectorDiv">
        <l-map
            :maxBounds="maxBounds"
            :minZoom="parseInt(2)"
            ref="map"
            style="width: 100%; height: 100%;"
            :zoom="zoom"
            :center="center"
            :options="option"
            :class="$store.state.search.targetSelecting ? 'leaflet-crosshair': ''"
        >
          <template mark="map">
            <l-tile-layer ref="mapLayer" :url="$store.state.map.mapUrl" :options="$store.state.map.mapSubdomains" />
            <l-tile-layer ref="infoLayer" v-show="!!$store.state.map.infoUrl" :url="$store.state.map.infoUrl"  :options="$store.state.map.mapSubdomains" />
          </template>
          <l-geo-json
              v-if="bufferGeo.geojson"
              :geojson="bufferGeo.geojson"
              :optionsStyle="bufferGeojsonStyle"
          ></l-geo-json>

          <l-geo-json
              v-if="$store.state.search.selectedRangeStore[$store.state.search.targetType] !== ''&& !targetMode"
              :geojson="$store.state.search.selectedRangeStore[$store.state.search.targetType]"
              :optionsStyle="targetGeojsonStyle"
          ></l-geo-json>



        </l-map>
        <div>
          <SearchRangeSelector ref="rangeSelector" style="position: absolute; top:84px;left: 0px; z-index: 9999;" />
        </div>


      </div>
      <div class="createVectorTitle" style="height:50px;margin-top:10px;">
        <div style="width: 1170px;height: 50px;float:left;">
          <a-input v-model="createSearchName" size="large" style="height: 50px;width:1170px;font-size: 14px;float:left;" placeholder="请输入矢量名称">

          </a-input>
        </div>
        <div v-if="createSearchName && $store.state.search.selectedRangeStore[$store.state.search.targetType]" class="createVectorButton" @click="createVectorSubmit">创建</div>
        <div v-else class="createVectorButton_grey">创建</div>
      </div>

    </a-modal>
    <!--矢量检验中-->
    <div v-if="showVectoryCheckLoading" style="position: fixed;top:50%;left:50%;z-index:10000000;">
      <a-spin tip="矢量检验中..." />
    </div>
    <!--查看矢量对话框-->
    <a-modal v-model="viewVectorModal"
             centered width="660px" :header="null"
             :footer="null"
    >
      <div class="overviewVectorDiv"  style="position:relative;z-index: 1000000;">
        <l-map
            :maxBounds="maxBounds"
            :minZoom="parseInt(2)"
            ref="map"
            style="width: 100%; height: 100%;z-index: 1000000;"
            :zoom="zoom"
            :center="center"
            :options="option"
            :class="$store.state.search.targetSelecting ? 'leaflet-crosshair': ''"
        >
          <template mark="map">
            <l-tile-layer ref="mapLayer" :url="$store.state.map.mapUrl" :options="$store.state.map.mapSubdomains" />
            <l-tile-layer ref="infoLayer" v-show="!!$store.state.map.infoUrl" :url="$store.state.map.infoUrl"  :options="$store.state.map.mapSubdomains" />
          </template>
          <l-geo-json
              v-if="bufferGeo.geojson"
              :geojson="bufferGeo.geojson"
              :optionsStyle="bufferGeojsonStyle"
          ></l-geo-json>

          <l-geo-json
              v-if="overviewGeo.geojson"
              :geojson="overviewGeo.geojson"
              :optionsStyle="targetGeojsonStyle"
          ></l-geo-json>
        </l-map>
      </div>

    </a-modal>
    <!--确认创建项目对话框-->
    <a-modal v-model="confirmCreateProjectModal"
             centered
             width="490"
             @ok="confirmCloseProject()">
      <div style="display:flex;justify-content:left;width:490px;min-height:60px;height:auto;padding-bottom:10px;margin-top: 20px;">


        <div class="shareListCtn">
            <span v-for="item in repositoryRemainlist" :key="item.repository_id">
              <span v-if="item.repository_name=='企业版'">
                 当前套件“{{item.repository_name}}”的剩余面积额度为<span style="color:#E02020;">{{(item.curRemainArea).toFixed(2)}}km<sup>2</sup></span>;<br/>
              </span>
            </span>
          <span v-for="item in vectorBufferedList" :key="item.id">
              <span v-if="item.new_area">矢量“{{item.shape_name}}”中有要素面积不足25平方公里，将自动扩充;<br/></span>
            </span>
          创建后只可增加不可删除，请谨慎选择。确定创建拆分: {{addProjectData.name}}?
        </div>

      </div>
      <template slot="footer">
        <a-button @click="confirmCreateProject()" type="danger">
          确定
        </a-button>
        <a-button @click="confirmCreateProjectModal=false">
          取消
        </a-button>
      </template>
    </a-modal>
    <!--矢量与套件无相交-->
    <a-modal v-model="noIntersectModal"
             centered
             width="490"
    >
      <div
          style="display:flex;justify-content:left;width:490px;min-height:60px;height:auto;padding-bottom:10px;margin-top: 20px;">
        <div style="width:63px;height: 63px;">
        </div>
        <div class="shareListCtn" style="line-height: 60px;color:#ffffff;">
          您选择的矢量与图源无相交区域，请重新选择!
        </div>

      </div>
      <template slot="footer">
        <a-button @click="noIntersectModal=false">
          重新选择
        </a-button>
      </template>
    </a-modal>
    <v-overlay :value="overlay">
      <span>正在处理，请稍后</span>
      <v-progress-circular indeterminate size="32"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :color=snackbarColor :timeout="timeout" bottom>
      {{snackbarInfo}}
      <v-btn dark text @click="snackbar = false" class="text-capitalize">
        {{$vuetify.lang.t('$vuetify.demand.close')}}</v-btn>
    </v-snackbar>

    <!-- 认证身份弹窗 -->
    <div class="shadow" v-if="shadowTip">
        <div class="shadowWhite">
            <img src="../assets/calendar/日历关闭.png" alt="" class="shadowClose" @click="shadowTip=false">
            <div class="shadowText1">用户身份认证</div>
            <div class="shadowText2">根据国家地理信息安全与保密相关规定，为规范数据使用，保障您的合法权益，购买和使用卫星遥感数据需完成<span style="font-weight: 600;">机构企业用户</span>/<span style="font-weight: 600;">教育科研用户</span>认证。（认证后可享受会员价格）</div>
            <div class="shadowSel" @click="authentication('/store/ApplyGovernmentMember')">
                <img src="../assets/dataPack/rsManage/企业用户.png" alt="" style="position: absolute;width: 100%;height: 100%;">
            </div>
            <div class="shadowSel" @click="authentication('/store/OpenEducationalCertification')" style="left: 400px;">
                <img src="../assets/dataPack/rsManage/教育用户.png" alt="" style="position: absolute;width: 100%;height: 100%;">
            </div>
        </div>
    </div>
    <!-- 机构企业：授权委托书（顶栏提示叠在蒙层上方） -->
    <div v-if="authLetterModalVisible" class="authLetterLayer">
        <div class="authLetterShadow" @click.self="closeAuthLetterModal">
            <div class="authLetterModal" @click.stop>
                <img src="../assets/calendar/日历关闭.png" alt="" class="authLetterClose" @click="closeAuthLetterModal">
                <div class="authLetterTitle">{{ authLetterTitle }}</div>
                <div class="authLetterDesc" v-if="authLetterModalMode!=='rejected'">{{ authLetterBodyText }}</div>
                <template v-else>
                    <div class="authLetterDesc">很抱歉，您的授权委托书未通过审核，请重新上传。</div>
                    <div class="authLetterReject" v-if="authorizationLetterRejectReason">未通过原因：{{ authorizationLetterRejectReason }}</div>
                </template>
                <div
                    class="authLetterDrop"
                    :class="{ 'authLetterDrop--active': authLetterDragOver }"
                    @click="triggerAuthFileInput"
                    @dragover.prevent="onAuthDragOver"
                    @dragleave.prevent="onAuthDragLeave"
                    @drop.prevent="onAuthFileDrop"
                >
                    <input
                        ref="authFileInput"
                        type="file"
                        class="authLetterFileInput"
                        accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                        @change="onAuthFileChange"
                    >
                    <div class="authLetterDropIcon" aria-hidden="true">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" fill="#1E81EB" fill-opacity="0.15"/>
                            <path d="M10 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" stroke="#1E81EB" stroke-width="1.2"/>
                            <path d="M12 9v6M9 12h6" stroke="#1E81EB" stroke-width="1.2" stroke-linecap="round"/>
                        </svg>
                    </div>
                    <div class="authLetterDropLine1">点击或将文件拖拽到这里上传</div>
                    <div class="authLetterDropLine2">支持扩展名：.pdf .jpg .png .jpeg</div>
                </div>
                <div class="authLetterFileRow" v-if="authLetterPendingName">
                    <span class="authLetterFileClip">&#128206;</span>
                    <span class="authLetterFileName">{{ authLetterPendingName }}</span>
                    <span class="authLetterFileRemove" @click.stop="clearAuthFile">×</span>
                </div>
                <div class="authLetterBar" v-if="authLetterPendingName"></div>
                <a
                    href="javascript:;"
                    class="authLetterLink"
                    :class="{ 'authLetterLink--disabled': authLetterTemplateLoading }"
                    @click.prevent="downloadAuthLetterTemplate"
                >{{ authLetterTemplateLoading ? '正在获取…' : '点击下载授权委托书模版' }}</a>
                <div class="authLetterBtns">
                    <div class="authLetterBtn1" :class="{ 'authLetterBtn1--disabled': authLetterUploading }" @click="confirmAuthLetterAction">{{ authLetterPrimaryLabel }}</div>
                    <div class="authLetterBtn2" v-if="!authLetterUploading" @click="closeAuthLetterModal">暂不上传</div>
                </div>
            </div>
        </div>
        <div v-if="authLetterTopTip" class="authLetterTopTip">
            <div
                class="authLetterTopTipInner"
                :class="'authLetterTopTipInner--' + authLetterTopTipType"
            >
                <span class="authLetterTopTipMark" v-if="authLetterTopTipType === 'success'">✓</span>
                <span class="authLetterTopTipMark" v-else>×</span>
                <span class="authLetterTopTipText">{{ authLetterTopTip }}</span>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

// import FlowMonit from "./FlowMonit";
import MainMap from '@comp/Maps/MainMap.vue'
import { bus } from '@/bus.js' //引入bus.js定义的空的Vue实例
import MapboxVectorLayer from 'ol/layer/MapboxVector';
import { Vector,Tile } from 'ol/layer';
import { XYZ } from 'ol/source'
import { Polygon, LineString, MultiPolygon,MultiLineString,Point } from 'ol/geom'
import Feature from 'ol/Feature';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';


import Axios from 'axios'
import coordtransform from 'coordtransform'
import { fromLonLat,toLonLat,transform } from 'ol/proj'
import {convertGPSToXY, convertXYToGPS, convertGPSToArray, convertArrayToGPS} from '../components/Maps/utils/convertGPSAndXY'
import SearchBar from '@comp/Maps/utils/SearchBar.vue'
import SearchRangeSelector from "@comp/Maps/SearchVector/SearchRangeSelector.vue";
// import CascaderSelect from "@comp/Cascader/Cascader.vue";
import handle from "ant-design-vue/lib/vc-slider/src/Handle";
import L from 'leaflet'
import { LMap,LMarker,LTileLayer,LGeoJson,LWMSTileLayer} from 'vue2-leaflet'
import 'leaflet-mouse-position'
import point from 'turf-point'
import booleanContains from '@turf/boolean-contains'
import WKT from "terraformer-wkt-parser"
import { GeoJSON, WFS, WMSCapabilities,WMTSCapabilities,WMSGetFeatureInfo,MVT,WKT as fmtWKT } from 'ol/format'

export default {
  name: "imageSegmentation",
  provide(){
    return{
      Home:this,// 允许一个祖先组件向其所有子孙后代注入一个依赖，不论组件层次有多深，并在起上下游关系成立的时间里始终生效。
      Search:this// 允许一个祖先组件向其所有子孙后代注入一个依赖，不论组件层次有多深，并在起上下游关系成立的时间里始终生效。
    }
  },
  components: {
    SearchRangeSelector,
    // CascaderSelect,
    // FlowMonit,
    SearchBar,
    MainMap,
    LMap,
    LTileLayer,
    LGeoJson,
  },
  data() {
    return {
      isMapVisible: true,

      id:null,
      areaName:null,
      repSubName:null,
      // leaflet参数
      // targetModePoint: L.latLng(380, 90),
      overviewGeo: {
        geojson: '',
        id:''
      },

      viewVectorModal: false,
      //以下是新增影像分割相关字段
      addProjectData:{
        name:'',
        start_time:'',
        end_time:'',
        description:'',
        shape_ids:[],//矢量库选择的矢量
        repository:{},//套件与选择的图层
        geojson:'',//上传矢量或勾画矢量
        layer:{}//选择的图层
      },
      editImgSeparateObj:{
        name:'',
        start_time:'',
        end_time:'',
        description:'',
        shape_ids:[],//矢量库选择的矢量
        repository:{},//套件与选择的图层
        geojson:'',//上传矢量或勾画矢量
      },
      editImgSeparateDialog:false,
      tempTime:[],//时间选择器
      vectorList:[],//矢量列表
      imgSeparateDialog:false,
      //新增影像分割之创建矢量
      //创建矢量
      createVectorModal:false,
      createSearchName:'',
      // 影像拆分弹窗 — 图源（分类 + 名称级联）
      splitSourceCategory: undefined,
      splitMkSeriesFlat: [],
      splitMkSeriesLoading: false,
      splitMkValue: undefined,
      splitDetailVisible: false,
      splitDetailLoading: false,
      splitDetailFlatRows: [],
      splitDetailPanelStyle: {},
      splitDetailForSeriesItem: null,
      splitDetailDocFn: null,
      rsManageSplitPresetRunning: false,
      repositoryRemainlist:[],//套件使用情况
      vectorBufferedList:[],//矢量外扩情况
      showVectoryCheckLoading:false,//数据检验中
      noIntersectModal:false,//无相交
      confirmCreateProjectModal:false,//确定创建弹窗
      splitImageList:[],//影像拆分列表
      selectedImgSectionId:'',
      locale,//时间插件文字中文

      // openlayers参数
      vectorInfo: {},//矢量信息
      nowTime: '',//现在时间

      // leaflet参数
      targetModePoint: L.latLng(380, 90),
      targetMode: false,
      zoom: 4,
      center: L.latLng(33.978292, 105.395057),
      maxBounds: L.latLngBounds([[85,-180], [-85,180]]),
      url: this.$store.state.mapUrl,
      subdomains: this.$store.state.mapSubdomains,
      option: { zoomControl: false, attributionControl: false, renderer: L.canvas() },
      targetGeojsonStyle: {
        color: '#00BCD4',
        weight: 2,
        fillOpacity: 0
      },
      bufferGeojsonStyle: {
        color: '#F44336',
        fillColor: '#F44336',
        weight: 2,
        fillOpacity: 0.1
      },
      bufferGeo: {
        geojson: '',
        area:''
      },
      //提示相关参数
      snackbar:false,
      snackbarColor:"",
      snackbarInfo:"",
      timeout: 3000,

      //其他字段
      rootUrl:"https://www.jl1mall.com",
      // rootUrl:"http://localhost:8080",
      toTopShow: false,
      connectStatus: false,

      // 流量记录变量
      isShadow:0,
      canChangeKey:false,
      second: 5,
      timer:"",
      screenHeight:1920,
      showKey:0,
      oldKey:0,
      showCount:0,
      freebackShow:true,
      repositoryId:"",
      mapdialog:false,
      // tk:"",
      tkList:[],
      timeList:[],
      // mkList:[],
      calendarShow:false,
      calendarHover:false,
      leftHover:false,
      rightHover:false,
      year:2023,
      //这个月份显示01-12
      month:1,
      //这个月份显示从0-11
      month1:0,
      day:1,
      dayList:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
      monthList:[1,2,3,4,5,6,7,8,9,10,11,12],
      list:[],
      sevenList:[],
      canLeft:true,
      canRight:true,
      dateCanShow:[],
      yearSelect:2023,
      monthSelect:0,
      daySelect:1,
      totalNum:0,
      mkNumList:[],
      canUseCount:100000,
      canUseCountToday:40000,
      totalNumToday:0,
      repositoryIdList:[],
      repositoryListChange:false,
      repositoryListCantChange:true,
      //控制2022各地区图像文件夹
      tabBlock2Select:[],
      newGuide:0,
      //地图
      showBak:true,
      tk: "",
      externalTk: "",
      sk: "",
      externalTkByPro: {},
      mapUrl:"",
      tileOrder:null,
      // tkList:[],
      // timeList:[],
      mkList:[],
      // mkThumbImg: [
      //   {url:require("../../assets/LayersThumb/0.png")},
      // ],
      // tileBaseUrl:'http://10.200.28.23:9090',
      tileBaseUrl:'https://api.jl1mall.com',
      // tileBaseUrl:'https://mt.jl1mall.com',
      lyrdata: [],
      mapCtrlTools4Use: [2],
      mapParams: {
        projection:'EPSG:3857', //注意：必须加上此投影才能显示地图，目前有效的是4326和3857，而4490暂未生效
        center:[108.29883, 35.72902], //地图初始化时的中心坐标【基于4326坐标系】
        // center:[142.85524, 43.61710], //地图初始化时的中心坐标【基于4326坐标系】
        // mExtent:[120.45536,35.55856,139.36943,44.78707], //左下点-右上点
        minZoom:1, //可以缩小的最小级别；若此处未定义，地图接收到undefined则表示不受限制
        maxZoom:18, //可以放大的最大级别；若此处未定义，地图接收到undefined则表示不受限制
        zoom:4, //地图初始化时显示级别；注意：若此处未定义，地图初始化显示不出来
      },
      //卷帘参数
      leftCompareName: '',//卷帘左侧select的值
      rightCompareName: '',//卷帘右侧select的值
      dataList: [],// 卷帘select的选项数据列表

      myLayersPanelShow:true,
      showMoreToolsPanel:false,
      showMyLayersAndVectorPanel: true,
      showMyLogoPanel: true,
      showRecordPanel: false,
      showIntroductionPanel: true,
      showMoreToolsTipPanel: false,
      showTipPanel: false,

      // 分屏参数
      fenpingName: ['','','',''],//分屏select的值

      // mkListChecked: [],
      checkBoxObj: {
        checkedList: ['2024年度全国高质量一张图'], // 此处需要一个默认值，保证初始选中
        tempCheckedList: ['2024年度全国高质量一张图'], // 此处需要一个默认值，保证初始选中
      },
      checkBoxVectorObj: {
        checkedList: [], // 此处需要一个默认值，保证初始选中
        tempCheckedList: [], // 此处需要一个默认值，保证初始选中
      },

      // 矢量参数
      tableData:[],
      /* 分页参数 */
      ipagination:{
        current: 1,
        pageSize: 1000,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        total: 0,
      },


      layersAndVectorsTabs: ['active', ''],
      loadGisMapRunOver: false,//用于判断mainmap是否加载完成

      overlay: false,
      shareLinkModal:false,//服务链接对话框
      shareList:[],

      curSelectTk:'',

      certified: false,//是否已认证
      shadowTip:false,
      authLetterModalVisible:false,
      authLetterModalMode:"initial",
      enterpriseCertInfoId:null,
      authorizationLetterRejectReason:"",
      authLetterPendingFile:null,
      authLetterPendingName:"",
      authLetterUploading:false,
      authLetterDragOver:false,
      authLetterCompanyName:"",
      authLetterCreditCode:"",
      authLetterTemplateLoading:false,
      authLetterTopTip:"",
      authLetterTopTipType:"success",
    };
  },
  methods: {
    // 前面是干啥的...
    goImgSparate(){
      //矢量
      this.getVectorLibrary()
      bus.$off('loadGisMapRunOver')
      bus.$on('loadGisMapRunOver', () => {
        this.showBak = false
        this.$refs.mainmap.curTk = this.tk
        this.loadGisMapRunOver=true
        // this.mapUrl=`${this.tileBaseUrl}/getTile/{z}/{x}/{-y}?mk=73ad26c4aa6957eef051ecc5a15308b4&tk=${this.tk}&vf=0`
      })
      this.getSplitImageList();
      setInterval(() => {
        this.nowTime=this.getNowTime()
      }, 1000);
    },
    orderListStart(){
      this.axios.post("/tilesapi/tiles/register/queryTileOrder",null, {
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
      }).then((res)=>{
        let data = res.data.data
        this.tileOrder = res
        if(data.length>0){
          for (let i = 0; i < data.length; i++) {
            const rep = data[i];
            if (rep.type=='1'&&rep.status=='已付款'&&rep.expireStatus!=2) {
              this.id = rep.repositoryId
              break
            }
            if(rep.type=='4'&&rep.postStatus=='已交付'&&rep.expireStatus!=2){
              this.id = rep.repCountyList[0].repositoryId
              break
            }
            if (rep.type=='0') {
              this.id = rep.repositoryId
              break
            }
          }
          this.repositoryId=this.id
          this.getTk()
          this.getExternalTk()
          this.goImgSparate()
        }
      })
    },
    checkAndShow(shape_id) {
      console.log(shape_id)
      let shape
      this.overlay=true

      let param=new FormData();
      param.append('id',shape_id)
      this.axios.post("/map_service_back/vectorLibrary/getVectorDetail", param)
          .then((response) => {
            shape = response.data.data.geojson

            this.clearAll()
            this.overviewGeo.geojson=JSON.parse(shape)
            this.overviewGeo.id=shape_id
            if (this.overviewGeo.geojson.coordinates.length > 10) {
              this.viewVectorModal = true;
              this.overlay=false

              this.$nextTick(() => {
                this.$refs.map.mapObject.fitBounds(L.geoJSON(this.overviewGeo.geojson).getBounds())
              })
              this.$message.error('暂不支持选择要素数量大于10的矢量创建项目');
              return
            }

            let param1=new FormData();
            // param.append('shape_id',shape_id);
            param1.append('geom',shape);
            this.axios
                .post("/map_service_back/program/geomAreaHandle", param1, {
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                }).then(res => {
              this.overlay=false

              if (res.data.needToBuffer) {
                this.bufferGeo.geojson=JSON.parse(res.data.data.geojson)
                this.bufferGeo.area=res.data.data.area
              } else {
                this.bufferGeo.geojson=''
                this.bufferGeo.area=''
              }
              this.viewVectorModal = true;
              this.$nextTick(() => {
                this.$refs.map.mapObject.fitBounds(L.geoJSON(this.overviewGeo.geojson).getBounds())
              })
            })
          })

    },
    rangePickerChange(data){
      console.log("待选日期发生变化")
      console.log(data)
      if(data.length<2){
        this.tempTime=[]
      }
      else {
        this.tempTime=data
      }
    },
    //影像分割编辑
    editImgSection(imgObj){
      console.log(imgObj)
      this.editImgSeparateDialog=true;
      let tempArray=[]
      if(imgObj.shapes){
        for(let i in imgObj.shapes){
          tempArray.push(imgObj.shapes[i].id)
        }
      }
      imgObj.tempShapeIds=imgObj.shape_ids;
      imgObj.shape_ids=[];
      this.editImgSeparateObj=imgObj;
      this.editImgSeparateObj.shape_ids=tempArray;
      this.tempTime[0]=imgObj.start_time;
      this.tempTime[1]=imgObj.end_time;
    },
    closeEditImgSection(){
      this.editImgSeparateDialog=false;
      this.editImgSeparateObj={
        name:'',
        start_time:'',
        end_time:'',
        description:'',
        shape_ids:[],//矢量库选择的矢量
        repository:{},//套件与选择的图层
        geojson:'',//上传矢量或勾画矢量
      }
      this.tempTime=[]//时间选择器
    },
    //提交修改
    clickSubmitEditProject(){
      let data = this.editImgSeparateObj;
      if(!data.name){
        this.$message.error('请输入项目名')
        return;
      }
      else if(!this.tempTime[0]||!this.tempTime[1]){
        this.$message.error('请输入起止时间')
        return;
      }
      let that = this;
      let param = new FormData();
      param.append('program_id', data.program_id);
      param.append('name', data.name);
      param.append('start_time', this.tempTime[0]);
      param.append('end_time', this.tempTime[1]);
      param.append('description', data.description);
      param.append('shape_ids', data.tempShapeIds);
      // param.append('repository', JSON.stringify(data.repository));
      param.append('map_source', `${data.mk}${data.annual_id?','+data.annual_id:''}`);
      this.axios
          .post("/map_service_back/program/editFlowSplitImage", param, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('编辑影像拆分')
        console.log(response)
        if (response.data.code == 200) {
          this.$message.success(response.data.message)
          this.editImgSeparateDialog=false;
          this.getSplitImageList();
        } else {
          this.$message.error(response.data.message);
        }

      })

    },
    //影像分割内容
    onChange(date, dateString) {
      console.log(date, dateString);
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().subtract(1, 'day').endOf('day');
    },
    closeImgSeparate(){
      this.imgSeparateDialog=false;
      this.resetSplitSourcePick();
    },
    createVector() {
      this.clearAll()
      this.createSearchName=''
      this.lyrdata = [
        {
          lyrType: "Tile",
          srcType: "XYZ",
          // mUrl:"https://t{0-7}.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=a1acdff888c05743e3603302c3f64a6d",
          mUrl: "https://t{0-7}.tianditu.gov.cn/DataServer?T=vec_w&X={x}&Y={y}&L={z}&tk=a1acdff888c05743e3603302c3f64a6d",
          mTitle: "路网",
          mName: "路网",
          mVisible: true
        },
        {
          lyrType: "Tile",
          srcType: "XYZ",
          mUrl: "https://t{0-7}.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=a1acdff888c05743e3603302c3f64a6d",
          mTitle: "文字标注",
          mName: "文字标注",
          mVisible: true
        }
      ],
          this.vectorInfo = {}
      this.createVectorModal = true;
      //zoom: 4,
      //center: L.latLng(33.978292, 105.395057),
      setTimeout(() => {
        this.$refs.map.mapObject.setView(this.center,this.zoom)
      },500)

    },
    getNowTime(){
      let dateTime = new Date();
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      let ri = dateTime.getDate();
      let day;
      switch (dateTime.getDay()) {
        case 0:
          day = "日";
          break;
        case 1:
          day = "一";
          break;
        case 2:
          day = "二";
          break;
        case 3:
          day = "三";
          break;
        case 4:
          day = "四";
          break;
        case 5:
          day = "五";
          break;
        case 6:
          day = "六";
          break;
        default:
          break;
      }
      let hours = dateTime.getHours();
      if(hours< 10){ hours="0" +hours }
      let minutes=dateTime.getMinutes();
      if(minutes< 10){ minutes="0" +minutes }
      let seconds=dateTime.getSeconds();
      if(seconds< 10){ seconds="0" +seconds }
      return year + "年" + month + "月" + ri + "日 星期"+ day + " " + hours + ":" +minutes + ":"+seconds;
    },
    getTodayTime() {
      let dateTime = new Date();
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      if(month< 10){ month="0" +month }
      let ri = dateTime.getDate();
      if(ri< 10){ ri="0" +ri }
      let hours = dateTime.getHours();
      if(hours< 10){ hours="0" +hours }
      let minutes=dateTime.getMinutes();
      if(minutes< 10){ minutes="0" +minutes }
      let seconds=dateTime.getSeconds();
      if (seconds < 10) { seconds = "0" + seconds }
      let time = year + "-" + month + "-" + ri + " " + hours + ":" + minutes + ":" + seconds
      return time;
    },
    clearAll() {
      this.$store.state.search.longitude = ''
      this.$store.state.search.latitude = ''
      this.$store.state.search.selectedRangeStore = {
        upload:'',
        china:'',
        world:'',
        point:'',
        draw:'',
        coordinatesArray:'',
        rectangle:'',
        circle:''
      }
    },
    createVectorSubmit() {
     

      // 校验同名矢量
      let fd=new FormData()
      fd.append("name",this.createSearchName)
      this.axios.post("/map_service_back/vectorLibrary/checkNameValid",fd,{
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }).then(res => {
        if (res.data.code == 200 && res.data.message == '校验成功') {
          let formdata = new FormData()
          let geom=JSON.stringify(this.$store.state.search.selectedRangeStore[this.$store.state.search.targetType])
          formdata.append("geojson",geom)
          formdata.append("name",this.createSearchName)
          this.axios.post("/map_service_back/vectorLibrary/insertVector",formdata,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then(res => {
            if (res.data.code==200) {
              this.snackbar=true
              this.snackbarColor = '#ff9900'
              this.snackbarInfo = `创建成功！`
              this.createVectorModal = false
              this.getVectorLibrary()
            } else {
              this.snackbar=true
              this.snackbarColor = '#ff0000'
              this.snackbarInfo = `创建失败！`
              this.createVectorModal=false
            }
          })
        } else {
          this.snackbar=true
          this.snackbarColor = '#ff0000'
          this.snackbarInfo = `不可存在同名矢量，请更改名称！`
        }
      })
    },
    //获取我的套件库
    resetSplitSourcePick() {
      this.splitSourceCategory = undefined;
      this.splitMkSeriesFlat = [];
      this.splitMkValue = undefined;
      this.splitMkSeriesLoading = false;
      this.closeSplitDetailPanel();
    },
    closeSplitDetailPanel() {
      this.splitDetailVisible = false;
      this.splitDetailLoading = false;
      this.splitDetailFlatRows = [];
      this.splitDetailForSeriesItem = null;
      this.splitDetailPanelStyle = {};
      if (this.splitDetailDocFn) {
        document.removeEventListener('mousedown', this.splitDetailDocFn);
        this.splitDetailDocFn = null;
      }
    },
    onSplitSourceCategoryChange() {
      this.splitMkValue = undefined;
      if (this.addProjectData) {
        this.addProjectData.repository = '';
      }
      this.closeSplitDetailPanel();
      this.splitMkSeriesFlat = [];
      if (!this.splitSourceCategory) {
        return;
      }
      this.loadSplitMkSeries(this.splitSourceCategory);
    },
    loadSplitMkSeries(type) {
      this.splitMkSeriesLoading = true;
      return this.axios.get("/tileflowapi/imagery/split/series", {
        params: { type },
        headers: { Authorization: "Bearer " + this.getKey() },
      }).then((res) => {
        this.splitMkSeriesLoading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg || "获取图源列表失败");
          const e = new Error("SERIES_BIZ_FAIL");
          e.isSeriesBizFail = true;
          return Promise.reject(e);
        }
        const data = res.data.data || [];
        const flat = [];
        const id = this.$route.query.id;
        const presetIv = this.$route.query.presetIv;
        data.forEach((group) => {
          const values = group.value || [];
          values.forEach((it) => {
            
            for(let i=0;i<this.mkList.length;i++){
              let m=this.mkList[i]
              if(m.annual_id==id&&m.tk_call==presetIv){
                this.curSelectTk=m.tk
                break
              }
            }
            flat.push({ ...it })
          });
        });
        this.splitMkSeriesFlat = flat;
      }).catch((err) => {
        this.splitMkSeriesLoading = false;
        if (!(err && err.isSeriesBizFail)) {
          this.$message.error("获取图源列表失败");
        }
        return Promise.reject(err);
      });
    },
    /** rsManage 带 ?id=&type= 进入：预填弹窗。勿对同地址做 router.replace 清 query：App.vue 的 router-view :key=fullPath 会整页重挂载导致弹窗被关掉。 */
    tryApplyRsManageSplitRoutePreset() {
      const id = this.$route.query.id;
      const type = this.$route.query.type;
      if (!id || (type !== "basic" && type !== "premium")) {
        return;
      }
      if (!this.tk) {
        return;
      }
      if (this.rsManageSplitPresetRunning) {
        return;
      }
      this.rsManageSplitPresetRunning = true;
      this.imgSeparateDialog = true;
      this.addProjectData = {
        name: "",
        start_time: "",
        end_time: "",
        description: "",
        shape_ids: "",
        group_id: "",
        repository: "",
        geojson: "",
        layer:""
      };
      this.resetSplitSourcePick();
      this.confirmCreateProjectModal = false;
      this.showVectoryCheckLoading = false;
      this.noIntersectModal = false;
      this.tempTime = [];
      this.splitSourceCategory = type;
      const presetName = this.$route.query.presetName;
      const presetIv = this.$route.query.presetIv;
      const presetPro = this.$route.query.presetPro;
      const presetIsAnnual = this.$route.query.presetIsAnnual;
      const presetAnnualId = this.$route.query.presetAnnualId;
      this.loadSplitMkSeries(type)
          .then(() => {
            const item = this.splitMkSeriesFlat.find((x) => String(x.id) === String(id));
            if (item) {
              this.splitMkValue = { key: item.id, label: item.name };
              // debugger
              this.applySplitRepositoryFromSeriesItem(item);
              return;
            }
            if (presetName) {
              const pseudo = {
                id,
                name: presetName,
                iv: presetIv,
                tk: this.curSelectTk,
                pro: presetPro,
                isAnnual: presetIsAnnual,
                annualId: presetAnnualId,
              };
              this.splitMkValue = { key: id, label: presetName };
              this.applySplitRepositoryFromSeriesItem(pseudo);
              return;
            }
            this.$message.warning("未找到对应的图源，请手动选择");
          })
          .catch(() => {})
          .finally(() => {
            this.rsManageSplitPresetRunning = false;
          });
    },
    onSplitMkArrowStopSelect(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    openSplitMkDetail(seriesItem, event) {
      this.closeSplitDetailPanel();
      this.splitDetailForSeriesItem = seriesItem;
      this.splitDetailVisible = true;
      this.splitDetailLoading = true;
      this.splitDetailFlatRows = [];
      const panelW = 332;
      const gap = 12;
      let left = event.clientX + 6;
      let top = event.clientY + 8;
      const menuDropdown =
          (event.target &&
              event.target.closest &&
              event.target.closest(".ant-select-dropdown:not(.ant-select-dropdown-hidden)")) ||
          Array.from(document.querySelectorAll(".ant-select-dropdown")).find(
              (el) => !el.classList.contains("ant-select-dropdown-hidden"),
          );
      const itemEl =
          event.target &&
          event.target.closest &&
          event.target.closest(".ant-select-dropdown-menu-item");
      if (menuDropdown) {
        const mr = menuDropdown.getBoundingClientRect();
        left = mr.right + gap;
      }
      if (itemEl) {
        const ir = itemEl.getBoundingClientRect();
        top = ir.top;
      }
      left = Math.max(8, Math.min(left, window.innerWidth - panelW - 8));
      const maxTop = window.innerHeight - 120;
      top = Math.max(8, Math.min(top, maxTop));
      this.splitDetailPanelStyle = {
        position: "fixed",
        left: left + "px",
        top: top + "px",
        zIndex: 10050,
        minWidth: "300px",
      };
      this.axios.get("/tileflowapi/imagery/mk/detail", {
        params: { mkId: seriesItem.id, callScenario: "jl1" },
        headers: { Authorization: "Bearer " + this.getKey() },
      }).then((res) => {
        this.splitDetailLoading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg || "获取子图源失败");
          this.closeSplitDetailPanel();
          return;
        }
        this.splitDetailFlatRows = this.flattenSplitDetailList(res.data.data || []);
        this.$nextTick(() => {
          this.splitDetailDocFn = (ev) => {
            const el = this.$refs.splitMkDetailPanel;
            if (el && el.contains(ev.target)) {
              return;
            }
            const inPrimaryDd =
                ev.target.closest &&
                ev.target.closest(".ant-select-dropdown:not(.ant-select-dropdown-hidden)");
            if (inPrimaryDd) {
              this.closeSplitDetailPanel();
              return;
            }
            this.closeSplitDetailPanel();
          };
          document.addEventListener("mousedown", this.splitDetailDocFn);
        });
      }).catch(() => {
        this.splitDetailLoading = false;
        this.$message.error("获取子图源失败");
        this.closeSplitDetailPanel();
      });
    },
    flattenSplitDetailList(list) {
      const rows = [];
      (list || []).forEach((item, idx) => {
        if (!item || item.isAnnual !== true) {
          return;
        }
        rows.push({
          key: `p-${item.id}-${idx}`,
          raw: item,
          isChild: false,
          name: item.name,
        });
      });
      return rows;
    },
    onPickSplitDetailRow(row) {
      const item = row.raw;
      this.splitMkValue = {
        key: `__detail__:${item.id}`,
        label: item.name,
      };
      this.applySplitRepositoryFromDetailItem(item);
      this.closeSplitDetailPanel();
    },
    // 没有套件概念了，不需要repository
    applySplitRepositoryFromSeriesItem(item) {
      // debugger
      // const repoId = this.tk;
      // if (!repoId) {
      //   this.$message.warning("信息未就绪，请稍后重试");
      //   return;
      // }
      // const mkId = item.iv || item.id;
      // this.addProjectData.repository = {
      //   list: [{ id: repoId, mk_ids: [mkId] }],
      // };
      // debugger
      this.addProjectData.layer={
        // mkId:item.id,
        mkIv:item.iv,
        name:item.name,
        tk:item.tk,
        pro:item.pro,
        annualId:item.isAnnual?item.annualId:''
      }
    },
    // 没有套件概念了，不需要repository
    applySplitRepositoryFromDetailItem(item) {
      // const repoId = item.tk || this.tk;
      // if (!repoId) {
      //   this.$message.warning("套件信息未就绪，请稍后重试");
      //   return;
      // }
      // const mkId = item.iv || item.id;
      // this.addProjectData.repository = {
      //   list: [{ id: repoId, mk_ids: [mkId] }],
      // };
      // debugger
      this.addProjectData.layer={
        // mkId:item.id,
        mkIv:item.iv,
        name:item.name,
        tk:item.tk,
        pro:item.pro,
        annualId:item.isAnnual?item.annualId:''
      }
    },
    onSplitMkValueChange(val) {
      if (!val || val.key === undefined || val.key === null) {
        this.closeSplitDetailPanel();
        this.splitMkValue = undefined;
        if (this.addProjectData) {
          this.addProjectData.repository = '';
        }
        return;
      }
      const keyStr = String(val.key);
      if (keyStr.startsWith("__detail__:")) {
        this.splitMkValue = {
          key: val.key,
          label: typeof val.label === "string" ? val.label : String(val.label || ""),
        };
        return;
      }
      const seriesItem = this.splitMkSeriesFlat.find((x) => x.id === val.key);
      if (!seriesItem) {
        this.closeSplitDetailPanel();
        this.splitMkValue = undefined;
        if (this.addProjectData) {
          this.addProjectData.repository = '';
        }
        return;
      }
      this.splitMkValue = {
        key: val.key,
        label: seriesItem.name,
      };
      // debugger
      this.applySplitRepositoryFromSeriesItem(seriesItem);
      this.closeSplitDetailPanel();
    },
    //影像拆分确定
    clickCreateSplit: function () {
      this.addProjectData.start_time=this.tempTime[0];
      this.addProjectData.end_time=this.tempTime[1];
      this.print(this.addProjectData);
      let param=this.addProjectData;
      if(!param.name){
        this.$message.error('请输入影像名称')
        return;
      }
      else if(!param.start_time||!param.end_time){
        this.$message.error('请输入起止时间')
        return;
      }
      else if(!param.layer || !param.layer.mkIv){
        this.$message.error('请选择图源')
        return;
      }
      // else if(!param.repository || !param.repository.list || param.repository.list.length < 1){
      //   this.$message.error('请选择图源')
      //   return;
      // }
      else if(param.shape_ids.length<1&&!param.geojson){
        this.$message.error('请选择矢量')
        return;
      }
      this.showVectoryCheckLoading=true;
      // let reposityIds=[]
      // for(let i=0;i<param.repository.list.length;i++){
      //   reposityIds.push(param.repository.list[i].id)
      // }

      // let chinaJs = JSON.parse(china)
      // debugger
      // let boolIntersect = false
      // chinaJs.features.some(chnElement => {
      //   if (booleanContains(chnElement, point)) {
      //     boolIntersect = true
      //     return true
      //   }
      // });
      let param_form=new FormData();
      // param_form.append('repository',JSON.stringify(this.addProjectData.repository));
      // param_form.append('mkId',this.addProjectData.layer.mkId);
      param_form.append('mkIv',this.addProjectData.layer.mkIv);
      param_form.append('name',this.addProjectData.layer.name);
      if (this.addProjectData.layer.tk) {
        param_form.append('tk',this.addProjectData.layer.tk);
      }
      if (this.addProjectData.layer.pro) {
        param_form.append('pro',this.addProjectData.layer.pro);
      }
      param_form.append('shape_ids',param.shape_ids.join(','));
      console.log('param_form')
      this.axios
      .post("/map_service_back/program/checkMkAndShpIntersection", param_form,{
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
      }).then((response) => {
        if(response.data.hasNotIntersect){
          console.log('无相交')
          // console.log(response.data.data)
          this.noIntersectModal=true;
          this.showVectoryCheckLoading=false;
        }else{
          // this.repositoryRemainlist=response.data.data;
          // console.log(this.repositoryRemainlist);
          // let remainList=this.repositoryRemainlist;
          this.showVectoryCheckLoading=false;
          // this.$message.success('通过套件剩余量检查，可继续使用')
          //NOTE 校验矢量面积，自动扩充
          let formdata = new FormData();
          // let shapes = { list: [{ id: "xxx", shape: "xxx" ,"area": "xxx" ,name:"xxx",create_time:"xxx" }] }
          let shapes = { list: [] }

          for (let i = 0; i < this.vectorList.length; i++) {
            const vector = this.vectorList[i];
            for (let j = 0; j < param.shape_ids.length; j++) {
              const shape_id = param.shape_ids[j];
              if (vector.id==shape_id) {
                shapes.list.push({ id: vector.id, shape: vector.shape, area: vector.area,name:vector.name,create_time:vector.create_time })
              }
            }
          }

          formdata.append('shapes', JSON.stringify(shapes));
          this.axios.post("/map_service_back/program/checkGeomArea", formdata,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then(res => {
            if (res.data.code==200) {
              this.vectorBufferedList = res.data.data
            }
            this.confirmCreateProjectModal = true;
            this.showVectoryCheckLoading=false;
          })
        }
      })
    },
    //影像拆分确定
    clickCreateSplit_bak: function () {
      this.addProjectData.start_time=this.tempTime[0];
      this.addProjectData.end_time=this.tempTime[1];
      this.print(this.addProjectData);
      let param=this.addProjectData;
      if(!param.name){
        this.$message.error('请输入影像名称')
        return;
      }
      else if(!param.start_time||!param.end_time){
        this.$message.error('请输入起止时间')
        return;
      }
      else if(!param.repository || !param.repository.list || param.repository.list.length < 1){
        this.$message.error('请选择图源')
        return;
      }
      else if(param.shape_ids.length<1&&!param.geojson){
        this.$message.error('请选择矢量')
        return;
      }
      this.showVectoryCheckLoading=true;
      // let reposityIds=[]
      // for(let i=0;i<param.repository.list.length;i++){
      //   reposityIds.push(param.repository.list[i].id)
      // }
      let param_form=new FormData();
      param_form.append('repository',JSON.stringify(this.addProjectData.repository));
      param_form.append('shape_ids',param.shape_ids.join(','));
      console.log('param_form')
      this.axios
          .post("/map_service_back/program/checkShpUseInReps", param_form,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        if(response.data.hasNotIntersect){
          console.log('无相交')
          console.log(response.data.data)
          this.noIntersectModal=true;
          this.showVectoryCheckLoading=false;
        }else {
          console.log('查看套件使用情况')
          this.repositoryRemainlist=response.data.data;
          console.log(this.repositoryRemainlist);
          let remainList=this.repositoryRemainlist;
          this.showVectoryCheckLoading=false;
          for(let i=0;i<remainList.length;i++){
            if(remainList[i].preArea>100000&&remainList[i].repository_name=="企业版"){
              this.$message.error('套件：'+remainList[i].repository_name+'的使用面积已超过10万平方公里,无法继续使用，请重新选择套件。')
              return;
            }
          }
          this.$message.success('通过套件剩余量检查，可继续使用')
          //NOTE 校验矢量面积，自动扩充
          let formdata = new FormData();
          // let shapes = { list: [{ id: "xxx", shape: "xxx" ,"area": "xxx" ,name:"xxx",create_time:"xxx" }] }
          let shapes = { list: [] }

          for (let i = 0; i < this.vectorList.length; i++) {
            const vector = this.vectorList[i];
            for (let j = 0; j < param.shape_ids.length; j++) {
              const shape_id = param.shape_ids[j];
              if (vector.id==shape_id) {
                shapes.list.push({ id: vector.id, shape: vector.shape, area: vector.area,name:vector.name,create_time:vector.create_time })
              }
            }
          }

          formdata.append('shapes', JSON.stringify(shapes));
          this.axios.post("/map_service_back/program/checkGeomArea", formdata,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then(res => {
            if (res.data.code==200) {
              this.vectorBufferedList = res.data.data
            }
            this.confirmCreateProjectModal = true;
            this.showVectoryCheckLoading=false;
          })
        }

      })
    },
    confirmCreateProject: function () {
      let shapes = { list: [] }
      this.vectorBufferedList.forEach(v => {
        if (v.new_area) {
          shapes.list.push({ id: v.shape_id, shape: v.buffered_geom, area: v.new_area,name:v.shape_name,create_time:v.create_time })
        } else {
          shapes.list.push({ id: v.shape_id, shape: v.old_geom, area: v.old_area,name:v.shape_name,create_time:v.create_time })
        }
      })

      let data = this.addProjectData;
      let that = this;
      let param = new FormData();
      // console.log(`${data.layer.mkIv}${data.layer.annualId?','+data.layer.annualId:''}`)
      
      param.append('name', data.name);
      param.append('start_time', data.start_time);
      param.append('end_time', data.end_time);
      param.append('description', data.description);
      param.append('shapes', JSON.stringify(shapes));
      // param.append('repository', JSON.stringify(data.repository));
      // debugger
      param.append('map_source', `${data.layer.mkIv}${data.layer.annualId?','+data.layer.annualId:''}`);
      param.append('geojson', data.geojson);
      this.axios
          .post("/map_service_back/program/insertFlowSplitImage", param, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('创建拆分')
        console.log(response)
        
        if (response.data.code == 200) {
          this.$message.success(response.data.message)
          that.addProjectData = {
            name: '',
            start_time: '',
            end_time: '',
            description: '',
            shape_ids: '',//矢量库选择的矢量
            group_id: '',
            repository: '',//套件与选择的图层
            geojson: '',//上传矢量或勾画矢量
            layer:''
          }
          this.resetSplitSourcePick()
          this.confirmCreateProjectModal = false;
          this.imgSeparateDialog = false;
          this.showVectoryCheckLoading = false //数据检验中
          this.noIntersectModal = false //无相交
          this.confirmCreateProjectModal = false //确定创建弹窗
          this.tempTime=[]
          this.getSplitImageList();
          

        } else {
          this.$message.error(response.data.message);
          this.confirmCreateProjectModal = false;
        }

      })

    },
    //获取影像分割列表
    getSplitImageList:function(){
      let param = new FormData();
      param.append('name', "");
      param.append('pageNum', 1);
      param.append('pageSize', 1000);

      this.axios
          .post("/map_service_back/program/getFlowSplitImageList", param, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('获取拆分影像列表')
        console.log(response)
        if(response.data.code==200){
          // 1. 隐藏地图
          this.isMapVisible = false;
          this.loadGisMapRunOver=false
          // 2. 等待 Vue 完成 DOM 移除
          this.$nextTick(() => {
            this.splitImageList=response.data.data;
            this.mkList=[]
            for(let i=0;i<this.splitImageList.length;i++){
              this.tabBlock2Select[i]=false
              this.mkList.push(...this.splitImageList[i].list)
            }
            // console.log(this.splitImageList)
  
            //底图用2024年全国一张图
            let baseLayer = {
                lyrType:"Tile",
                srcType:"XYZ",
                mUrl:`${this.tileBaseUrl}/getTile/{z}/{x}/{-y}?mk=3ddec00f5f435270285ffc7ad1a60ce5&tk=${this.tk}&vf=0`,
                mTitle:'2024年全国一张图（底图）',
                mName: '2024年全国一张图（底图）',
                mType:4,
                mExtent:[],
                mVisible:true,
                sk:this.sk
            }
            // console.log('temp.mTitle',temp.mTitle)
            // let subUrl = temp.mUrl.replace(/^.*(?=\/getTile)/, '')  
            // console.log('temp.mUrl',subUrl)
            this.lyrdata.push(baseLayer)
  
            for(let i=0;i<this.mkList.length;i++){
              let v=this.mkList[i]
              // 创建 GeoJSON 格式化器
              const format = new GeoJSON({
                // 可选：指定数据投影（通常是 EPSG:4326）
                dataProjection: 'EPSG:4326',
                // 可选：指定要素投影（通常是地图使用的投影）
                featureProjection: 'EPSG:4326'
              });
  
              // 读取 GeoJSON 并获取范围
              const features = format.readFeatures(JSON.parse(v.shapes[0].geojson))
              const extent = features[0].getGeometry().getExtent();
              console.log('extent',extent)
              console.log('this.sk',this.sk)
              let temp = {
                  lyrType:"Tile",
                  srcType:"XYZ",
                  mUrl:`${this.tileBaseUrl}/getTile/{z}/{x}/{-y}?mk=${v.mk}&tk=${v.tk?v.tk:this.tk}${v.program_id?'&pro='+v.program_id:''}&vf=0`,
                  mTitle:v.name,
                  mName: v.name,
                  mType: v.type,
                  mExtent:(extent&&extent.length>0)?extent:[],
                  mVisible:false,
                  sk:v.sk?v.sk:this.sk
              }
              // console.log('temp.mTitle',temp.mTitle)
              // let subUrl = temp.mUrl.replace(/^.*(?=\/getTile)/, '')  
              // console.log('temp.mUrl',subUrl)
              this.lyrdata.push(temp)
            }
            this.lyrdata.push({
                lyrType:"lVector",
                srcType:"Vector",
                mUrl:'',
                mTitle:"边框",
                mName:"边框",
                mVisible:true
            })
            this.isMapVisible = true;
            if (this.loadGisMapRunOver) {
              this.$refs.mainmap.curTk = this.tk
            }

          });

        }

      })
    },
    //点击服务链接
    clickServiceLink: function (imgObj) {
      if (!this.certified) {
          this.verifyUserCertification()
          return
      }
      console.log(imgObj)
      let url=`${this.tileBaseUrl}/getTile/{z}/{x}/{-y}?mk=${imgObj.mk}&tk=${this.getImgExternalTk(imgObj)}&pro=${imgObj.program_id}`
      this.shareList = [{name:imgObj.name,url:url}]
      this.shareLinkModal = true;
    },
    verifyUserCertification() {
      this.axios.get("/loginapi/getUserForUserCenter", {
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
      }).then((res) => {
        if (res.status == 200) {
          const d = res.data && res.data.data;
          if (!d) {
            alert("系统错误");
            return;
          }
          const certificationIdentity = String(d.certificationIdentity);
          if (certificationIdentity === "2" || certificationIdentity === "3") {
            this.completeCertification();
            return;
          }
          const ecRaw = d.enterpriseCertStatus;
          const ecStr = ecRaw === null || ecRaw === undefined || ecRaw === "" ? "" : String(ecRaw).trim();
          if (ecStr === "" || ecStr === "null") {
            this.shadowTip = true;
            return;
          }
          if (ecStr === "1") {
            this.jumpWithPermission("仅实名", "/store/VIPBenefits", "/rskit" + this.$route.fullPath);
            return;
          }
          if (ecStr === "0" || ecStr === "2" || ecStr === "3") {
            this.loadEnterpriseCertInfo();
          } else {
            this.shadowTip = true;
          }
        } else {
          alert("系统错误");
        }
      }).catch(() => {
        alert("系统错误");
      });
    },
    completeCertification() {
      this.certified = true;
      this.shadowTip = false;
      this.authLetterModalVisible = false;
      this.clearAuthFile();
      this.clearAuthLetterTip();
      this.showValidationTip("认证成功，请重新操作");
    },
    showValidationTip(msg) {
      if (this.$message) {
        this.$message.warning(msg);
      } else {
        alert(msg);
      }
    },
    mapAuthorizationLetterView(statusRaw) {
      if (statusRaw === null || statusRaw === undefined || statusRaw === "") return "initial";
      const t = String(statusRaw).trim();
      if (t === "null" || t === "undefined") return "initial";
      if (t === "未通过" || t.includes("未通过")) return "rejected";
      if (t === "审核中" || t.includes("审核中")) return "pending";
      if (t === "已通过" || t.includes("已通过")) return "proceed";
      if (t === "0" || t === 0) return "initial";
      if (t === "1" || t === 1) return "pending";
      if (t === "2" || t === 2) return "proceed";
      if (t === "3" || t === 3) return "rejected";
      return "initial";
    },
    loadEnterpriseCertInfo() {
      this.axios
        .get("/accessapi/enterprise/cert/getUserEnterpriseCertInfo", {
          headers: { Authorization: "Bearer " + this.getKey() },
        })
        .then((res) => {
          const body = res.data;
          const data = (body && (body.data !== undefined ? body.data : body)) || {};
          this.enterpriseCertInfoId = data.id != null ? data.id : (data.certId != null ? data.certId : null);
          this.authLetterCompanyName = (data.companyName != null ? data.companyName : "").toString().trim();
          this.authLetterCreditCode = (data.creditCode != null ? data.creditCode : "").toString().trim();
          this.authorizationLetterRejectReason = (
            data.authorizationLetterRejectReason
            || data.rejectReason
            || data.refuseReason
            || data.authorizationRefuseReason
            || ""
          ).toString().trim();
          this.clearAuthFile();
          this.clearAuthLetterTip();
          const mode = this.mapAuthorizationLetterView(data.authorizationLetterStatus);
          if (mode === "proceed") {
            this.completeCertification();
            return;
          }
          this.authLetterModalMode = mode;
          this.authLetterModalVisible = true;
        })
        .catch(() => {
          this.showValidationTip("获取企业认证信息失败");
        });
    },
    showAuthLetterTip(msg, type) {
      this.authLetterTopTip = msg || "";
      this.authLetterTopTipType = type === "success" ? "success" : "error";
    },
    clearAuthLetterTip() {
      this.authLetterTopTip = "";
    },
    closeAuthLetterModal() {
      this.authLetterModalVisible = false;
      this.clearAuthFile();
      this.clearAuthLetterTip();
    },
    openAuthFilePicker() {
      if (this.$refs.authFileInput) {
        this.$refs.authFileInput.value = "";
        this.$refs.authFileInput.click();
      }
    },
    triggerAuthFileInput() {
      this.openAuthFilePicker();
    },
    onAuthDragOver() {
      this.authLetterDragOver = true;
    },
    onAuthDragLeave() {
      this.authLetterDragOver = false;
    },
    onAuthFileDrop(e) {
      this.authLetterDragOver = false;
      const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      this.applyAuthPickedFile(f);
    },
    onAuthFileChange(e) {
      const f = e.target && e.target.files && e.target.files[0];
      this.applyAuthPickedFile(f);
    },
    applyAuthPickedFile(file) {
      if (!file) return;
      this.authLetterPendingFile = file;
      this.authLetterPendingName = file.name;
    },
    clearAuthFile() {
      this.authLetterPendingFile = null;
      this.authLetterPendingName = "";
      if (this.$refs.authFileInput) {
        this.$refs.authFileInput.value = "";
      }
    },
    isAuthFileValidType(file) {
      if (!file || !file.name) return false;
      const n = file.name.toLowerCase();
      return n.endsWith(".pdf") || n.endsWith(".jpg") || n.endsWith(".jpeg") || n.endsWith(".png");
    },
    validateAuthFileForUpload() {
      const f = this.authLetterPendingFile;
      if (!f) {
        this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
        return false;
      }
      const maxBytes = 20 * 1024 * 1024;
      if (f.size > maxBytes) {
        this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
        return false;
      }
      if (!this.isAuthFileValidType(f)) {
        this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
        return false;
      }
      return true;
    },
    downloadAuthLetterTemplate() {
      if (this.authLetterTemplateLoading) {
        return;
      }
      const name = (this.authLetterCompanyName || "").trim();
      const code = (this.authLetterCreditCode || "").trim();
      if (!name || !code) {
        this.showAuthLetterTip("企业名称或统一社会信用代码缺失，请刷新页面后重试", "error");
        return;
      }
      this.authLetterTemplateLoading = true;
      this.clearAuthLetterTip();
      const fd = new FormData();
      fd.append("companyName", name);
      fd.append("creditCode", code);
      this.axios
        .post("/accessapi/enterprise/cert/getAuthorizationLetter", fd, {
          headers: {
            Authorization: "Bearer " + this.getKey(),
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          const body = res.data || {};
          if (body.status === 200 && body.data) {
            const url = typeof body.data === "string" ? body.data : (body.data.url || body.data);
            if (url) {
              window.open(url, "_blank");
            } else {
              this.showAuthLetterTip("未获取到模板地址", "error");
            }
          } else {
            this.showAuthLetterTip(
              (body.message && String(body.message)) || "获取模板失败，请稍后重试",
              "error",
            );
          }
        })
        .catch(() => {
          this.showAuthLetterTip("获取模板失败，请稍后重试", "error");
        })
        .finally(() => {
          this.authLetterTemplateLoading = false;
        });
    },
    postAuthorizationLetter() {
      if (!this.enterpriseCertInfoId) {
        this.showAuthLetterTip("企业认证信息不完整，请刷新页面后重试", "error");
        return;
      }
      if (!this.validateAuthFileForUpload()) return;
      this.clearAuthLetterTip();
      const fd = new FormData();
      fd.append("id", this.enterpriseCertInfoId);
      fd.append("authorizationLetter", this.authLetterPendingFile);
      this.authLetterUploading = true;
      this.axios
        .post("/accessapi/enterprise/cert/uploadAuthorizationLetter", fd, {
          headers: {
            Authorization: "Bearer " + this.getKey(),
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          const d = res.data || {};
          if (d.status != null && d.status !== 200) {
            this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
            return;
          }
          if (d.code != null && d.code !== 200 && d.code !== 0) {
            this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
            return;
          }
          if (d.success === false) {
            this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
            return;
          }
          this.showValidationTip("上传成功，预计在1-3个工作日内完成审核");
          this.closeAuthLetterModal();
        })
        .catch(() => {
          this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
        })
        .finally(() => {
          this.authLetterUploading = false;
        });
    },
    confirmAuthLetterAction() {
      if (this.authLetterUploading) return;
      this.postAuthorizationLetter();
    },
    //导出分享链接
    exportShareList: function () {
      let dataList=this.shareList;
      let str='名称,地址\n';
      // 增加\t为了不让表格显示科学计数法或者其他格式
      for(let i = 0 ; i < dataList.length ; i++ ){
        for(const key in dataList[i]){
          if(key=='name'||key=='url')
            str+=`${dataList[i][key] + '\t'},`;
        }
        str+='\n';
      }
      console.log(str)
      // encodeURIComponent解决中文乱码
      const uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str);
      // 通过创建a标签实现
      const link = document.createElement("a");
      link.href = uri;
      // 对下载的文件命名
      link.download =  "服务链接表.csv";
      link.click();
      this.$message.success('导出成功')


    },
    // 选择影像拆分图层
    chooseImgSection: function (imgObj) {
      this.overlay=true
      this.selectedImgSectionId = imgObj.program_id;
      let param = new FormData()
      param.append('program_id', imgObj.program_id)
      param.append('mk', imgObj.mk)
      param.append('tk', imgObj.tk||this.tk)
      // let url=`${this.tileBaseUrl}/getTile/{z}/{x}/{-y}?mk=${imgObj.mk}&tk=${imgObj.tk}&pro=${imgObj.program_id}&vf=0`
      this.axios
          .post("/map_service_back/program/getExtentByProgram", param, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((res) => {
            this.overlay=false

            let allLayers = this.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
            allLayers.forEach(layer => {
              // if (layer instanceof Tile) {
              //   layer.setVisible(false)
              // }
              // if (layer.values_.title == '2024年度全国高质量一张图') {
              //   // layer.setVisible(true)
              //   layer.getSource().setUrl(url)
              // }
              if (layer instanceof Tile && layer.values_.title == imgObj.name) {
                layer.setVisible(true)
                let mkType=layer.values_.type
                let packageType = [1, 4].includes(mkType) ? 'basic' : 'premium'
                
                this.axios.get("/tileflowapi/imagery/traffic/situation", {
                  params: {
                    packageType: packageType,
                    mkType: mkType,
                  },
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                }).then((res) => {
                  const data = res.data && res.data.code === 200 && res.data.data ? res.data.data : null;
                  if (data) {
                    this.exhaustedFlowType = data.flowType != null ? String(data.flowType) : "";
                    if (this.exhaustedFlowType == 'none' || data.isFlowExhausted === true) {
                      bus.$emit('limitZoom',true)//判断是否zoom大于12
                      // this.flowExhaustedModalVisible = true;
                    } else {
                      bus.$emit('limitZoom',false)
                      // this.flowExhaustedModalVisible = false;
                    }
                  }

                })


              }else if(layer instanceof Tile && layer.values_.title !='文字标注'){
                layer.setVisible(false)
              }
              if (layer instanceof Vector && layer.values_.title == '边框') {
                layer.getSource().clear()
                if (res.data.intersectionGeoJson) {
                  // TODO 加上点线
                  let geom = JSON.parse(res.data.intersectionGeoJson)
                  let feature=new Feature({
                    geometry: geom.type=='MultiPolygon'?new MultiPolygon(geom.coordinates):new Polygon(geom.coordinates)
                  })
                  feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
                  layer.getSource().addFeature(feature)
                  let ext = layer.getSource().getExtent()
                  if (this.$refs.mainmap.location.getFeatures().length == 0) {
                    this.$refs.mainmap.map.getView().fit(ext)
                  }
                }
              }
            })
          })
      console.log(imgObj)
    },
    chooseImgSection_bak: function (imgObj) {
      this.overlay=true
      this.selectedImgSectionId = imgObj.program_id;
      let param = new FormData()
      param.append('program_id', imgObj.program_id)
      param.append('mk', imgObj.mk)
      let url=`${this.tileBaseUrl}/getTile/{z}/{x}/{-y}?mk=${imgObj.mk}&tk=${imgObj.tk}&pro=${imgObj.program_id}&vf=0`
      this.axios
          .post("/map_service_back/program/getExtentByProgram", param, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((res) => {
            this.overlay=false

            let allLayers = this.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
            allLayers.forEach(layer => {
              // if (layer instanceof Tile) {
              //   layer.setVisible(false)
              // }
              if (layer.values_.title == '2024年度全国高质量一张图') {
                // layer.setVisible(true)
                layer.getSource().setUrl(url)
              }
              if (layer instanceof Vector && layer.values_.title == '边框') {
                layer.getSource().clear()
                if (res.data.intersectionGeoJson) {
                  // TODO 加上点线
                  let geom = JSON.parse(res.data.intersectionGeoJson)
                  let feature=new Feature({
                    geometry: geom.type=='MultiPolygon'?new MultiPolygon(geom.coordinates):new Polygon(geom.coordinates)
                  })
                  feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
                  layer.getSource().addFeature(feature)
                  let ext = layer.getSource().getExtent()
                  if (this.$refs.mainmap.location.getFeatures().length == 0) {
                    this.$refs.mainmap.map.getView().fit(ext)
                  }
                }
              }
            })
          })
      console.log(imgObj)
    },
    clickCreateImgSeparate:function () {
      this.imgSeparateDialog=true;
      this.addProjectData = {
        name: '',
        start_time: '',
        end_time: '',
        description: '',
        shape_ids: '',//矢量库选择的矢量
        group_id: '',
        repository: '',//套件与选择的图层
        geojson: '',//上传矢量或勾画矢量
        layer:''
      }
      this.resetSplitSourcePick()
      this.confirmCreateProjectModal = false;
      this.showVectoryCheckLoading = false //数据检验中
      this.noIntersectModal = false //无相交
      this.confirmCreateProjectModal = false //确定创建弹窗
      this.tempTime=[]
    },

    fileOpen(index,i,item){
      if (i == 1) {
        this.tabBlock2Select[index]=true
      }else{
        this.tabBlock2Select[index]=false
      }
    },

    //带权限判断的跳转
    jumpWithPermission(type,path,fromUrl){
      //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
      //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
      let loginUserId=localStorage.getItem('userId');//是否已登录
      let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
      if(type=='可游客'){
        if(fromUrl){
          window.open(this.rootUrl+path+"?fromUrl="+this.rootUrl+fromUrl,"_self")
        }
        else {
          window.open(this.rootUrl+path,"_self")
        }
      }else if(type=='仅登录'){
        //已登录
        if(loginUserId){
          if(fromUrl){
            window.open(this.rootUrl+path+"?fromUrl="+this.rootUrl+fromUrl,"_self")
          }
          else {
            window.open(this.rootUrl+path,"_self")
          }
        }
        //未登录
        else {
          if(fromUrl){
            window.open(this.rootUrl+'/Login'+"?fromUrl="+this.rootUrl+fromUrl,"_self")
          }
          else {
            window.open(this.rootUrl+'/Login',"_self")
          }
        }
      } else if (type == '仅实名') {
        //已登录
        if(loginUserId){
          //已实名
          if(authentication=='0'){
            if(fromUrl){
              window.open(this.rootUrl+path+"?fromUrl="+this.rootUrl+fromUrl,"_self")
            }
            else {
              window.open(this.rootUrl+path,"_self")
            }
          }else if(type=='仅登录'){
            //已登录
            if(loginUserId){
              if(fromUrl){
                window.open(this.rootUrl+path+"?fromUrl="+this.rootUrl+fromUrl,"_self")
              }
              else {
                window.open(this.rootUrl+path,"_self")
              }
            }
            //未登录
            else {
              if(fromUrl){
                window.open(this.rootUrl+'/Login'+"?fromUrl="+this.rootUrl+fromUrl,"_self")
              }
              else {
                window.open(this.rootUrl+'/Login',"_self")
              }
            }
          }else if(type=='仅实名'){
            //已登录
            if(loginUserId){
              //已实名
              if(authentication=='0'){
                if(fromUrl){
                  window.open(this.rootUrl+path+"?fromUrl="+this.rootUrl+fromUrl,"_self")
                }
                else {
                  window.open(this.rootUrl+path,"_self")
                }
              }
              //未实名
              else {
                window.open(this.rootUrl+'/Authentication',"_self")
              }

            }
            //未登录
            else {
              if(fromUrl){
                window.open(this.rootUrl+'/Login'+"?fromUrl="+this.rootUrl+fromUrl,"_self")
              }
              else {
                window.open(this.rootUrl+'/Login',"_self")
              }
            }
          }
          //未实名
          else {
            window.open(this.rootUrl+'/Authentication',"_self")
          }

        }
        //未登录
        else {
          if(fromUrl){
            window.open(this.rootUrl+'/Login'+"?fromUrl="+this.rootUrl+fromUrl,"_self")
          }
          else {
            window.open(this.rootUrl+'/Login',"_self")
          }
        }
      }
    },
    getKey() {
      return localStorage.getItem("token");
    },
    getLoginInfo() {
      console.log("getLoginInfo")
      console.log(this.getKey())
      let that = this;
      this.axios
          .get("/loginapi/getLoginInfo", {
            headers: {
              'Cache-Control': 'no-cache',
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            if (res.data.success) {
              console.log("主页顶bar，getLoginInfo信息");
              this.print(res.data);
              this.$store.state.user.userId = res.data.data.account;
              this.$store.state.user.name = res.data.data.name;
              this.$store.state.user.vipLevel = res.data.data.vipLevel;
              this.setCookie("userId", res.data.data.account);
              this.setCookie(
                  "userInfo",
                  JSON.stringify({
                    phone: res.data.data.phone,
                    location: res.data.data.location,
                  })
              );
              this.$store.state.user.logined = true;
              let authentication = res.data.data.authentication
              this.$store.state.user.authentication =authentication; //是否实名认证，0是，1否
              this.setLocalStorageItem("authentication",authentication); //是否实名认证，0是，1否;为方便其他系统用
              this.setLocalStorageItem('token',res.data.data.key); //getuserInfo也需要赋值token，为把三部token替换为本部门token
              this.authenticationStatus=res.data.data.authentication
              this.vipLevel = res.data.data.vipLevel;
              this.vipType = res.data.data.vipType;
              this.vipActivityStatus = res.data.data.vipActivityStatus;
              this.avatar = res.data.data.avatar;
              if (res.data.data.endTime) {
                this.vip_endTime = res.data.data.endTime.split(" ")[0];
              }
            } else {
              this.$store.state.user.logined = false;
              // if (that.getCookie("userId")) {
              setTimeout(() => {
                this.$store.state.user.userId = "";
                // this.setCookie('userId', "");
                localStorage.setItem("userId", "");
                // this.$router.push("/Login");
                this.jumpWithPermission('仅实名','/rskit/viewMapSource','/rskit/viewMapSource')
              }, 2000);
              // }
            }
          });
    },
    setLocalStorageItem(key, value) {
      localStorage.setItem(key, value);
    },
    // getTk() {//获取套件list
    //   this.axios.get("/tilesapi/tiles/repository/queryViewMapRepositoryMkDir",{
    //     headers: {
    //       Authorization: "Bearer " + this.getKey(),
    //     },
    //   }).then((res) => {
    //     let result = res.data.data
    //     this.mkList=[]
    //     if (res.data.code==200) {
    //       let tempTK = ''
    //       result.forEach(data => {
    //         // 判断全国一张图
    //         if(data.name&&data.name.includes('2024年度全国高质量一张图')){
    //             data.mkList.forEach(mapItem => {
    //               mapItem.choose = true
    //               tempTK = mapItem.tkIv
    //               this.mkList.push(mapItem)
    //             });
    //         }
    //       });
    //       // 添加所有图层
    //       this.lyrdata = []
    //       this.mkList.forEach(v => {
    //         let temp = {
    //             lyrType:"Tile",
    //             srcType:"XYZ",
    //             mUrl:`${this.tileBaseUrl}/getTile/{z}/{x}/{-y}?mk=${v.mkIv}&tk=${v.tkIv}&vf=0`,
    //             mTitle:v.name,
    //             mName:v.name,
    //             mExtent:v.extent?v.extent.split(','):[],
    //             mVisible:v.choose
    //         }
    //         this.lyrdata.push(temp)
    //       })
    //       this.lyrdata.push({
    //           lyrType:"lVector",
    //           srcType:"Vector",
    //           mUrl:'',
    //           mTitle:"边框",
    //           mName:"边框",
    //           mVisible:true
    //       })
    //       this.tk = tempTK
    //       if (this.loadGisMapRunOver) {
    //         this.$refs.mainmap.curTk = this.tk
    //       }
    //     }
    //   })
    // },
    getTk() {
      this.axios.get("/tileflowapi/imagery/getUserTk", {
        params: { callScenario: "jl1" },
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
      }).then(res => {
        if (res.data.code==200) {
          this.tk = res.data.data.tk
          this.sk = res.data.data.sk
          // this.loadMkList();
          this.$nextTick(() => {
            this.tryApplyRsManageSplitRoutePreset();
          });
        }
      });
    },
    getExternalTk() {
      this.axios.get("/tileflowapi/imagery/getUserTk", {
        params: { callScenario: "external" },
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
      }).then(res => {
        if (res.data.code == 200) {
          this.certified = res.data.data.certified
          this.externalTk = res.data.data.tk
        }
      });
    },
    /** 拉取 external 场景图源列表，建立 pro(拆分id) → 外部tk 映射，用于服务链接使用各自对应拆分图源的外部tk */
    loadExternalMkTkMap() {
      const loadByType = (type) => {
        return this.axios.get("/tileflowapi/imagery/mk/list", {
          params: { type, callScenario: "external", purchasedOnly: false },
          headers: { Authorization: "Bearer " + this.getKey() },
        }).then((res) => {
          const body = res && res.data;
          if (body && Number(body.code) === 200 && Array.isArray(body.data)) {
            const iter = (nodes) => {
              (nodes || []).forEach((node) => {
                if (node && String(node.type) === "split" && node.pro && node.tk) {
                  this.externalTkByPro[node.pro] = node.tk;
                }
                if (Array.isArray(node.value)) {
                  iter(node.value);
                }
              });
            };
            body.data.forEach((group) => iter(group.value));
          }
        }).catch(() => {});
      };
      return Promise.all([loadByType("basic"), loadByType("premium")]);
    },
    /** 获取拆分图源服务链接使用的外部tk：优先用该拆分 pro(program_id) 对应节点的外部tk，否则回退公共外部tk */
    getImgExternalTk(imgObj) {
      const byPro = imgObj && imgObj.program_id ? this.externalTkByPro[imgObj.program_id] : null;
      return byPro || this.externalTk;
    },
    // async loadMkList() {
    //   let axiosArr = []
    //   axiosArr.push(this.axios.get("/tileflowapi/imagery/mk/series", {params: { type:"basic", callScenario: "jl1" },headers: {Authorization: "Bearer " + this.getKey()}}))
    //   axiosArr.push(this.axios.get("/tileflowapi/imagery/mk/series", {params: { type:"premium", callScenario: "jl1" },headers: {Authorization: "Bearer " + this.getKey()}}))
      
    //   let res = await Promise.all(axiosArr)

    //   
    //   for (let index = 0; index < res.length; index++) {
    //     const r = res[index];
    //     let data = r.data.data || [];
    //     console.log('data',data)
    //   }
    // },
    async onVectorChangeOption(checkedList) {
      if (checkedList.length < 1) { // 实现必须有一个选中的效果
        this.checkBoxVectorObj.checkedList = this.checkBoxVectorObj.tempCheckedList; // 点击选中项不能取消选中
        return;
      }

      checkedList = checkedList.slice(1); // 实现单选效果

      // console.log('checkedList',checkedList)
      this.checkBoxVectorObj.tempCheckedList = checkedList; // 缓存当前选中项，在取消选中时使用
      this.checkBoxVectorObj.checkedList = checkedList; // 更新选中

      let shape=''
      for (let i = 0; i < this.tableData.length; i++) {
        let vec = this.tableData[i];
        if (vec.name==checkedList[0]) {
          // shape=vec.shape
          this.overlay=true
          let param=new FormData();
          param.append('id',vec.id)
          await this.axios.post("/map_service_back/vectorLibrary/getVectorDetail", param)
              .then((response) => {
                this.overlay=false
                shape = response.data.data.geojson
              })
          break
        }
      }


      let allLayers = this.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
      allLayers.forEach(layer => {
        if (layer instanceof Vector && layer.values_.title=='边框') {
          layer.getSource().clear()
          let geom = JSON.parse(shape)
          let geometry
          if (geom.type=='MultiPolygon') {
            geometry=new MultiPolygon(geom.coordinates)
          }
          if (geom.type == 'Polygon') {
            geometry=new Polygon(geom.coordinates)
          }
          if (geom.type == 'LineString') {
            geometry=new LineString(geom.coordinates)
          }
          if (geom.type == 'MultiLineString') {
            geometry=new MultiLineString(geom.coordinates)
          }
          let feature=new Feature({
            geometry: geometry
          })
          feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
          layer.getSource().addFeature(feature)
          let ext = layer.getSource().getExtent()
          if (this.$refs.mainmap.location.getFeatures().length == 0) {
            this.$refs.mainmap.map.getView().fit(ext)
          }
        }

      })
    },
    getVectorLibrary(){
      let param=new FormData();
      param.append('pageNum',this.ipagination.current);
      param.append('pageSize',this.ipagination.pageSize);
      this.axios
          .post("/map_service_back/vectorLibrary/getVectorLibrary", param,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log(response)
        if (response.data.code==200) {
          this.vectorList = response.data.data;
          //只保留面状矢量
          this.vectorList=this.vectorList.filter(item=>item.shape_type.includes('POLYGON'))

          this.tableData=response.data.data;
          this.ipagination.total=response.data.total;
          // this.checkBoxVectorObj.checkedList=[]
          // this.checkBoxVectorObj.tempCheckedList = []
          this.checkBoxVectorObj.checkedList=[this.tableData.length>0?this.tableData[0].name:'']
          this.checkBoxVectorObj.tempCheckedList = [this.tableData.length>0?this.tableData[0].name:'']
        }
      })
    },

    authentication(path) {
        window.open(this.rootUrl+path,'_self')
    }
  },
  created() {
    //如果从商城端跳入，同步token状态
    let token=this.$route.query.tk;
    if(token){
      this.setLocalStorageItem('token',token);
    }

    this.getLoginInfo();
    //定时判断用户登录状态，每分钟一次，如果是登录超时则返回登录页
    this.$nextTick(() => {
      setInterval(this.getIfTimeout, 600000);
    });
  },
  mounted() {
    this.getTk();
    this.getExternalTk();
    this.loadExternalMkTkMap();
    this.goImgSparate()
    // this.orderListStart();
  },
  beforeDestroy() {
    this.closeSplitDetailPanel();
  },
  computed: {
    authLetterTitle() {
      if (this.authLetterModalMode === "pending") return "授权委托书审核中";
      return "上传授权委托书";
    },
    authLetterBodyText() {
      if (this.authLetterModalMode === "pending") {
        return "您上传的授权委托书正在审核中，请耐心等待。";
      }
      return "根据平台管理要求，机构企业用户购买遥感商城产品需要签署授权委托书并盖章上传，审核通过后可享受专属购买权益。";
    },
    authLetterPrimaryLabel() {
      return this.authLetterModalMode === "initial" ? "确认上传" : "重新上传";
    },
  },
  watch:{
    $route() {
      if (this.$route.name !== "imageSegmentation") {
        return;
      }
      this.$nextTick(() => {
        this.tryApplyRsManageSplitRoutePreset();
      });
    },
  },
}
</script>

<style lang="scss" scoped>

.shareListCtn {
  width: 620px;
  height: auto;
  min-height: 60px;
  max-height: 420px;
  overflow-y: auto;
  font-size: 18px;
  padding-left: 10px;
  word-break: break-all;
  color:#ffffff;
}

.shareListCtn::-webkit-scrollbar {
  width: 4px;
}

.shareListCtn::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.shareListCtn::-webkit-scrollbar-track {
}
::v-deep .ant-checkbox-disabled + span {
  color: rgb(189, 189, 189);
  cursor: not-allowed;
}
::v-deep .ant-calendar-range-picker-input{
  font-size: 14px;
}
::v-deep .ant-select-selection__placeholder{
  margin-top: -7px;
}
::v-deep .ant-select-selection-selected-value{
  margin-top: 5px;
}
::v-deep .ant-select-selection {
  display: block;
  box-sizing: border-box;
  background: #2a2a2a;
  color: #b9b9b9;
  border: 1px solid #b9b9b9;
  border-top-width: 1.02px;
  border-radius: 4px;
  outline: none;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  height: 40px;
}
::v-deep .ant-modal-content {
  position: relative;
  background-color: #2A2A2A;
  background-clip: padding-box;
  border: 0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: auto;
}
.overviewVectorDiv{
  width: 660px;
  height: 570px;
  // border:solid 1px #FF0000;
}
.createVectorButton{
  margin-left: 10px;
  float:left;
  width: 98px;
  height: 50px;
  border-radius: 8px;
  background: #1E81EB;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  line-height: 50px;
  cursor:pointer;
}
.createVectorButton_grey{
  margin-left: 10px;
  float:left;
  width: 98px;
  height: 50px;
  border-radius: 8px;
  background: #F5F5F6;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #575757;
  text-align: center;
  line-height: 50px;
}
.createVectorTitle{
  width: 1280px;
  height:40px;
  line-height: 40px;
  margin-bottom: 20px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
.createVectorDiv{
  width: 1280px;
  height: 600px;
  // border:solid 1px #9b2121;
}
.tableCtn{
  width: 100%;
  height:500px;
  padding-right: 20px;
  margin-top: 35px;
}
.searchAddCtn{
  width: 100%;
  padding-left: 180px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-top: -10px;
}
::v-deep .ant-input {
  color: #ffffff;
}
.i-bottomCtn{
  display: flex;
  justify-content: center;
  width: 100%;
  height: 65px;
  border-top: solid 1px rgb(151, 151, 151);
  padding-top: 12px;
  .i-button{
    width: 102px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #979797;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #FFFFFF;
    cursor:pointer;
  }
}
.createProjectLine {
  display: flex;
  justify-content: left;
  width: 100%;
  height: auto;
  min-height: 40px;
  margin-bottom: 20px;
  .item-name {
    position: relative;
    width: 90px;
    height: 40px;
    text-align: left;
    line-height: 40px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #ffffff;
  }

  .item-input {
    width: 560px;
    min-height: 40px;
    height: auto;
    .edit-tj-ctn{
      width: 100%;
      min-height: 100px;
      height:auto;
      border-radius: 8px;
      border: solid 1px #d7d7d7;
      .item-ctn{
        width:100%;
        height:auto;
        padding:0px 10px 5px 10px;
        .tj-title{
          height:35px;
          line-height: 35px;
          font-size: 16px;
          width: auto;
        }
        .mk-ctn{
          width: 100%;
          min-height: 30px;
          line-height: 30px;
          border:dashed 1px #d0d0d0;
          padding: 3px;
          display: flex;
          justify-content: left;
          flex-wrap:wrap;
          .mk-item{
            height:24px;
            line-height: 24px;
            text-align: center;
            padding-left:3px;
            padding-right:3px;
            border-radius: 5px;
            border:solid 1px #75adee;
            font-size: 14px;
            min-width: 40px;
            width:auto;
            margin-right: 10px;
            margin-bottom:5px;
            margin-top:5px;
          }
        }
      }
    }
    .vectorCtn{
      width: 100%;
      height: 150px;
      color: #b9b9b9;
      .vectorListCtn{
        width: 100%;
        height: 110px;
        overflow-y: scroll;
        .itemCtn {
          height: 30px;
          line-height: 30px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
        }
      }
    }
  }
}
.createImgSeparateDialog{
  width: 715px;
  min-height: 514px;
  background: #2A2A2A;
  .i-titleCtn{
    position: relative;
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-bottom: 1px solid #979797;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
  .i-middleCtn{
    padding-top: 15px;
    padding-left: 35px;
    width: 100%;
    height: 450px;
  }
}
.shadow-imgSeparate {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}
.createImgSeparateCtn{
  width: 159px;
  height: 41px;
  background: rgba(255,255,255,0.1);
  border-radius: 8px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 20px;
  line-height: 41px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #FFFFFF;
  cursor:pointer;
}
.mapdiv{
  position: absolute;
  // width: calc(100% - 10px);
  // height: calc(100% - 10px);
  // left: 5px;
  // top: 5px;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.bak{
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url('~@assets/Laboratory/背景.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
// ::v-deep .searchBar,
// ::v-deep .dfmAllDiv,
// ::v-deep .searchList{
//   left: 500px;
// }
// ::v-deep .dfmBtnDiv{
//   left: 710px;
// }

.laboratoryLogo{
  position: relative;
  .mark{
    position: absolute;
    width: 100px;
    height: 100vh;
    left: 0;
    top: 0;
    // background: linear-gradient(270deg, rgba(0,0,0,0) 20%, rgba(0,0,0,0) 77%, rgba(0,0,0,0.25) 88%, #000000 100%);
    background: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 40%, rgba(0, 0, 0, 0.5) 60%, #000000 100%);
  }
  .recordBtn{
    position: absolute;
    right: 30px;
    top: 90px;
    background: url('~@assets/Laboratory/流量查看_默认.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 54px;
    height: 54px;
    cursor: pointer;
  }
  .recordBtn:hover{
    background: url('~@assets/Laboratory/流量查看_hover.png');
  }
  .logoPanel{
    position: absolute;
    width: 440px;
    height: 54px;
    background: #2A2A2A;
    border-radius: 8px;
    top: 15px;
    left: 15px;
    .panelDoms{
      display: flex;
      align-items: center;
      height: 100%;
      .hoverNavi{
        cursor: pointer;
        background: url('~@assets/Laboratory/导航按钮_黑底.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 44px;
        height: 44px;
        margin-left: 17px;
      }
      .hoverNavi:hover{
        background: url('~@assets/Laboratory/导航按钮_黑底_hover.png');
      }
      .hoverLogoContent{
        position: fixed;
        top: 60px;
        left: 20px;
        width: 0px;
        height: 0px;
        overflow: hidden;
        z-index: 1000;
      }
      .hoverWhite{
        position: fixed;
        top: 76px;
        left: 20px;
        width: 0px;
        height: 0px;
        background: #000;
        box-shadow: 2px 2px 10px 2px rgba(255,255,255,0.2);
        border-radius: 16px;
        transition: 0.3s;
        overflow: hidden;
        z-index: 1000;
      }
      .hoverMainImg{
        position: absolute;
        top: 20px;
        left: 44px;
        width: 175px;
        height: 40px;
      }
      .hoverJiantou{
        position: absolute;
        width: 18px;
        height: 16px;
        top: 35px;
        left: 433px;
      }
      .hoverLine{
        position: absolute;
        top: 80px;
        left: 28px;
        width: 444px;
        height: 1px;
        border-top: 1px solid #CCCCCC;
      }
      .hoverLogo{
        position: absolute;
        top: 100px;
        left: 28px;
        width: 220px;
        height: 60px;
        background: #000;
        border-radius: 6px;
      }
      .hoverLogo:hover{
        background: rgba(0,0,0,0.7);
      }
      .hoverImg{
        position: absolute;
        top: 19px;
        left: 24px;
        width: 20px;
        height: 20px;
      }
      .hoverLogoText1{
        position: absolute;
        top: 17px;
        left: 66px;
        width: 85px;
        height: 24px;
        font-size: 20px;
        font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
        font-weight: normal;
        color: #fff;
        line-height: 24px;
      }
      .hoverLogoText2{
        position: absolute;
        top: 35px;
        left: 66px;
        width: 133px;
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: rgba(255,255,255,0.7);
        line-height: 17px;
        opacity: 0;
      }
      .dashedLine{
        width: 1px;
        height: 26px;
        border: 1px solid rgba(255,255,255,0.75);
        margin-left: 15px;
      }
      .logo{
        background: url('~@assets/Laboratory/实验室logo_white.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 132px;
        height: 42px;
        margin-left: 25px;
        margin-top: 5px;
      }
      .introductionBtn{
        cursor: pointer;
        position: absolute;
        // top: 12px;
        right: 14px;
        width: 54px;
        height: 30px;
        background: rgba(255,255,255,0.15);
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;

        font-size: 14px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #EAEAEA;
        line-height: 20px;
      }
    }

    .moreTools{
      position: absolute;
      width: calc(100vw - 580px);
      height: 54px;
      background: #2A2A2A;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 0;
      left: 445px;
      z-index: 1000;

      font-size: 14px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #CCCCCC;
      line-height: 20px;

      .closeImg{
        position: absolute;
        right: 11px;
        cursor: pointer;
      }
    }
    .closePanel{
      position: absolute;
      right: -25px;
      top: 0px;
      cursor: pointer;
      background: url('~@assets/Laboratory/展开按钮_默认.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 20px;
      height: 54px;
    }
    .closePanel:hover{
      background: url('~@assets/Laboratory/展开按钮_hover.png');
    }
  }
  .layersAndVectorsPanel{
    position: absolute;
    width: 440px;
    height: 100vh;
    background: #2A2A2A;
    top: 0px;
    left: 0px;
    z-index: 1;
    /* 勾选框样式，有点乱 */
    ::v-deep .ant-checkbox-checked::after{
      background: url('~@assets/Laboratory/单选框选中.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border: unset;
      transform: unset;
      visibility: unset;
      box-shadow: 1px 1px 2px 0px rgba(184,184,184,0.5), inset 0px 0px 2px 0px rgba(0,0,0,0.5);
    }
    ::v-deep .ant-checkbox-disabled{
      background: url('~@assets/Laboratory/单选框选中.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    ::v-deep .ant-checkbox-checked .ant-checkbox-inner::after{
      opacity: unset;
      transform: unset;
      border: unset !important;
    }
    ::v-deep .ant-checkbox-inner::after{
      border: unset;
    }
    ::v-deep .ant-checkbox-checked .ant-checkbox-inner{
      background-color: unset;
      border: unset;
    }
    ::v-deep .ant-checkbox-inner{
      background-color: unset;
      background: url('~@assets/Laboratory/单选框默认.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border: unset;
      transform: unset;
      visibility: unset;
      box-shadow: 1px 1px 2px 0px rgba(184,184,184,0.5), inset 0px 0px 2px 0px rgba(0,0,0,0.5);
    }


    ::v-deep .ant-select-selection{
      background: rgba(0,0,0,0.5);
      color: white;
    }
    ::v-deep .ant-select-arrow{
      color: white;
    }

    .tabs{
      width: 100%;
      height: 56px;
      line-height: 56px;
      display: flex;
      border-bottom: 1px solid rgba(255,255,255,0.25);
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 14px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #FFFFFF;
      line-height: 20px;
      background: rgba(0,102,204,0.15);


    }

    .ps {
      // height: 885px;
      // height: 1782px;
      height: calc(100vh - 156px);
      position: unset;
      .ps__rail-y,
      .ps__rail-y.ps__thumb-y{
        right: 18px !important;
      }
    }
    .tabPanels{
      color: white;
      height: calc(100% - 56px);
      // 滚动条样式

      .layersPanel{
        position: relative;
        max-height: 100%;
        overflow-y: auto;
        // overflow-y: hidden;
        overflow-x: hidden;
        // >div:nth-child(1){
        .ant-checkbox-group{
          margin-left: 20px;
          // width: 100%;
          // width: calc(100% - 30px);
          width: calc(100% - 20px);
        }
      }
      // .layersPanel:hover{
      //   overflow-y: overlay;
      // }
      .layersLi{
        position: relative;
        display: flex;
        align-items: center;
        height: 54px;
        color: #FFFFFF;
        font-weight: 400;
        .thumbImg{
          width: 42px;
          height: 42px;
          border: 1px solid rgba(255,255,255,0.2);
          margin-left: 15px;
          margin-right: 15px;
          img{
            width: 42px;
            height: 42px;
            padding: 5px;
          }
        }
        .mkInfo{
          >div:nth-child(2){
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #979797;
            line-height: 17px;
          }
        }
        .juanlianBtn{
          cursor: pointer;
          position: absolute;
          right: 10px;
          background: url('~@assets/Laboratory/卷帘对比_默认.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 30px;
          height: 30px;
        }
        .juanlianBtn:hover{
          background: url('~@assets/Laboratory/卷帘对比_hover.png');
        }
      }
      .vectorLi{
        .thumbImg{
          img{
            padding: 10px;
          }
        }
      }
    }
    .closePanel{
      position: absolute;
      top: calc(50% - 74px);
      right: -25px;
      cursor: pointer;
      background: url('~@assets/Laboratory/收起按钮_默认.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 20px;
      height: 54px;
    }
    .closePanel:hover{
      background: url('~@assets/Laboratory/收起按钮_hover.png');
    }
  }

  .closePanelImg{
    cursor: pointer;
    position: absolute;
    left: 15px;
    top: calc(50vh - 54px);
    width: 20px;
    height: 54px;
    background: url('~@assets/Laboratory/展开按钮_默认.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .closePanelImg:hover{
    background: url('~@assets/Laboratory/展开按钮_hover.png');
  }
}

.shadow {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;
  .dialog {
    position: absolute;
    width: 1080px;
    height: 680px;
    border-radius: 16px;
    left: calc(50% - 540px);
    top: calc(50% - 340px);
    z-index: 10001;
    background: #2A2A2A;

    // overflow-y: auto;
    // overflow-x: hidden;
    .dialogImg {
      position: absolute;
      top: 0;
      right: -50px;
      cursor: pointer;
    }
    .introductionImg{
      width: 100%;
      // max-height: 100%;
      // overflow-y: auto;
    }
  }
}
.dialog .introduction{
  overflow-y: auto;
  overflow-x: hidden;
  // overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  padding: 10px;
  // 滚动条样式
  .ps {
    height: 660px;
  }
}
// .dialog .introduction:hover{
//   overflow-y: overlay;
// }

.shadow_tools_tip {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;
  .dialog {
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    position: absolute;
    width: 768px;
    height: 460px;
    border-radius: 16px;
    left: calc(50% - 384px);
    top: calc(50% - 230px);
    z-index: 10001;
    background: #2A2A2A;
    .dialogImg {
      position: absolute;
      top: 0;
      right: -50px;
      cursor: pointer;
    }
    >div:nth-child(2){
      width: 36px;
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 25px;
      margin: 50px 0;
    }
    >div:nth-child(3){
      width: 600px;
      height: 120px;
      font-size: 16px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #FFFFFF;
      line-height: 30px;
    }
    >div:nth-child(4){
      margin: 100px 0;
    }
  }
}
.shadow_tip {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;
  .dialog {
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    position: absolute;
    width: 768px;
    height: 460px;
    border-radius: 16px;
    left: calc(50% - 384px);
    top: calc(50% - 230px);
    z-index: 10001;
    background: #2A2A2A;

    >div:nth-child(1){
      width: 36px;
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 25px;
      margin: 50px 0;
    }
    >div:nth-child(2){
      width: 600px;
      height: 120px;
      font-size: 16px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #FFFFFF;
      line-height: 30px;
    }
    >div:nth-child(3){
      margin: 100px 0;
    }
  }
}
.tabsNavi{
  position: absolute;
  width: calc(100vw - 440px);
  height: 56px;
  background: #2A2A2A;
  top: 0;
  left: 440px;
}
.tabsNavi-s{
  position: absolute;
  width: 100vw;
  height: 56px;
  background: #2A2A2A;
  top: 0;
  left: 0px;
}
.tabsNaviInput{
  position: absolute;
  top: 0;
  left: 25px;
  width: 262px;
  height: 42px;
  border-bottom: 1px solid #FFFFFF;
  opacity: 0.7;
}
.tabsNaviInput1{
  position: absolute;
  width: 250px;
  top: 15px;
  left:0px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 500;
  color: #fff;
  line-height: 20px;
  border:none;
  outline: none;
}
.tabsNaviSearch{
  position: absolute;
  top: 18px;
  right: 5px;
  cursor: pointer;
}
.tabsNaviChange{
  position: absolute;
  top: 17px;
  left: calc(50% - 175px);
  width:350px;
  height: 40px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #979797;
  line-height: 20px;
  cursor: pointer;
  text-align: right;
  padding-right: 20px;
}
.tabsNaviList{
  position: absolute;
  top:40px;
  right:-20px;
  width: auto;
  height:auto;
  box-shadow: 0px 0px 5px 0px rgba(255,255,255,0.2);
  border-radius: 8px;
}
.tabsNaviList1{
  background: #2A2A2A;
  width:auto;
  height: 60px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #979797;
  line-height: 20px;
  background: #2A2A2A;
  cursor: pointer;
  padding-top: 10px;
  padding-left: 40px;
  padding-right: 40px;
  text-align: left;
}
.tabsNaviList1:hover{
  background: grey;
  color: #3a3a3a;

}
.tabsNaviList11{
  background: #2A2A2A;
  width:auto;
  height: 60px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #979797;
  line-height: 20px;
  background: #2A2A2A;
  cursor: pointer;
  padding-top: 10px;
  padding-left: 40px;
  padding-right: 40px;
  text-align: left;
  border-radius: 8px 8px 0 0;
}
.tabsNaviList11:hover{
  background: grey;
  color: #3a3a3a;

}
.tabsNaviList12{
  background: #2A2A2A;
  width:auto;
  height: 60px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #979797;
  line-height: 20px;
  background: #2A2A2A;
  cursor: pointer;
  padding-top: 10px;
  padding-left: 40px;
  padding-right: 40px;
  text-align: left;
  border-radius: 0 0 8px 8px;
}
.tabsNaviList12:hover{
  background: grey;
  color: #3a3a3a;

}
.tabsNaviClose{
  position: absolute;
  top: 17px;
  right: 40px;
  width: 28px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #CCCCCC;
  line-height: 20px;
  cursor: pointer;
}
.tabPanelsSearch{
  position: relative;
  margin-top: 27px;
  margin-left: 19px;
  width: 400px;
  height: 44px;
  background: #3A3A3A;
  border-radius: 22px;
}
.tabPanelsBlock1{
  position: relative;
  margin-left: 4px;
  width: 431px;
  height: 52px;
  cursor: pointer;
}
.tabPanelsBlock1-s{
  position: relative;
  margin-left: 4px;
  width: 431px;
  height: 52px;
  background: rgba(0,102,204,0.1);
  cursor: pointer;
}
.tabPanelsBlock1:hover{
  background: rgba(0,102,204,0.1);
}
.tabBlock1Select{
  position: absolute;
  top: 19px;
  left: 13px;
}
.tabBlock1Text1{
  position: absolute;
  top: 5px;
  left: 96px;
  width:350px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #FFFFFF;
  line-height: 20px;
}
.tabBlock1Text2{
  position: absolute;
  top: 32px;
  left: 115px;
  width: 40px;
  height: 16px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 17px;
}
.tabBlock1Text3{
  position: absolute;
  top: 40px;
  left: 96px;
  width: 300px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #979797;
  line-height: 20px;
}
.tabBlock1Button1{
  position: absolute;
  top: 90px;
  left: 153px;
  width: 125px;
  height: 32px;
  background: #EAEAEA;
  border-radius: 8px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #3A3A3A;
  line-height:32px;
  text-align: center;
  cursor: pointer;
}
.newGuideShadow{
  position: fixed;
  left: 440px;
  top: 0;
  width: calc(100vw - 440px);
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuide1Text1{
  position: absolute;
  top: 54px;
  left: 131px;
  width: 250px;
  height: 30px;
  font-size: 24px;
  font-family: HanziPenSC-W5, HanziPenSC;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 30px;
}
.newGuide4Text1{
  position: absolute;
  top: 0px;
  right: 70px;
  width: 250px;
  height: 30px;
  font-size: 24px;
  font-family: HanziPenSC-W5, HanziPenSC;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 30px;
}
.newGuide1Block{
  position: absolute;
  top: 99px;
  left: 30px;
  width: 400px;
  height: 300px;
  border-radius: 8px;
  border: 2px solid #FFFFFF;
}
.newGuide4Block{
  position: absolute;
  top: 40px;
  right: 30px;
  width: 400px;
  height: 300px;
  border-radius: 8px;
  border: 2px solid #FFFFFF;
}
.newGuideBlock1{
  position: absolute;
  top: 6px;
  left: 6px;
  width: 386px;
  height: 286px;
  border-radius: 3px;
  border: 1px solid rgba(255, 255, 255, 0.5);
}
.newGuide1Text2{
  position: absolute;
  top: 19px;
  left: 28px;
  width: 330px;
  height: 185px;
  font-size: 21px;
  font-family: HanziPenSC-W5, HanziPenSC;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 35px;
}
.newGuide1Button1{
  position: absolute;
  top: 233px;
  left: 83px;
  width: 100px;
  height: 30px;
  background: #FFFFFF;
  border-radius: 8px;
  font-size: 21px;
  font-family: HanziPenSC-W5, HanziPenSC;
  font-weight: normal;
  color: #000;
  line-height: 35px;
  text-align: center;
  cursor: pointer;
}
.newGuideShadow31{
  position: fixed;
  left: 0px;
  top: 0;
  width: 440px;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuideShadow32{
  position: fixed;
  left: 770px;
  top: 0px;
  width: calc(100vw - 770px);
  height: 85px;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuideShadow33{
  position: fixed;
  left: 440px;
  top:85px;
  width: calc(100vw - 440px);
  height: calc(100vh - 85px);
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuideShadow41{
  position: fixed;
  left: 0px;
  bottom:375px;
  width: 100vw;
  height: calc(100vh - 375px);
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuideShadow42{
  position: fixed;
  left: 0px;
  right: 150px;
  bottom:0px;
  width: calc(100vw - 150px);
  height: 375px;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuideShadow43{
  position: fixed;
  right: 0px;
  bottom:0px;
  width: 150px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.fenpingShadow{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.shadowContent11{
  position: fixed;
  top: calc(50% - 160px);
  left: calc(50% - 400px);
  width: 800px;
  height: 320px;
  background: #FFFFFF;
  border-radius: 12px;
}
.shadowText11{
  position: absolute;
  top: 50px;
  left: calc(50% - 150px);
  width: 300px;
  height: 60px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 25px;
  line-height: 30px;
  text-align: center;
}
.shadowText22{
  position: absolute;
  top: 124px;
  left: 120px;
  width: 560px;
  height: 50px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #3A3A3A;
  line-height: 25px;
  text-align: center;
}
.shadowButton11{
  position: absolute;
  top:234px;
  left:261px;
  width: 169px;
  height: 40px;
  background: #0066CC;
  border-radius: 6px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.shadowButton22{
  position: absolute;
  top: 234px;
  left: calc(50% - 50px);
  width: 100px;
  height: 40px;
  background: #FFFFFF;
  border-radius: 6px;
  border: 1px solid #0066CC;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #0066CC;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}


</style>
<!-- 流量样式 -->
<style scoped>
.bar{
  position: relative;
  width: 100%;
  height: 76px;
  background-color: #fff;
}
.freeback{
  position: relative;
  width: 100%;
  height: 40px;
  background: #0066CC;
}
.freebackBlue{
  position: absolute;
  width: 1920px;
  height: 40px;
}
.freebackText{
  position: absolute;
  left:50%;
  transform:translate(-50%,0);
  width: 800px;
  height:40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height:40px;
  text-align: center;
  z-index: 1;
}
.freebackClose{
  position: absolute;
  width: 14px;
  height: 14px;
  right: 50px;
  top: 13px;
  cursor: pointer;
}
.navi{
  position: relative;
  width: 100%;
  height: 40px;
  background: #F5F5F6;
}
.naviContent{
  position: absolute;
  width: 1920px;
  height: 40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 40px;
  padding-left: 120px;
}
.greyBasis{
  position: relative;
  width: 100%;
  height: auto;
  background-color: #fff;
  overflow: hidden;
}
.basisTitle{
  position: absolute;
  top: 43px;
  left: calc(50% - 201px);
  width: 402px;
  height: 42px;
  z-index: 1;
}
.basisText1{
  position: absolute;
  top: 53px;
  left: calc(50% - 400px);
  width:800px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 22px;
  text-align: center;
  z-index: 2;
}
.greyContent{
  margin-top: 50px;
  margin-left: calc(50% - 640px);
  width: 1280px;
  height:auto;
  background: #F7F7F7;
  border-radius: 16px;
  padding-bottom: 20px;
  margin-bottom: 50px;
  overflow: hidden;
}
.keyManage{
  position: relative;
  margin-left: calc(50% - 560px);
  width: 1120px;
  height: 48px;
  /* background-color: pink; */
  margin-top: 75px;
  margin-bottom: 50px;
}
.greyList{
  position: relative;
  margin-left: calc(50% - 560px);
  margin-bottom: 10px;
  width: 1120px;
  height: 54px;
  background: #FFFFFF;
  border-radius: 8px;
  overflow: hidden;
}
.greyListBlock{
  position: relative;
  margin-top: 17px;
  margin-left: 222px;
  margin-bottom: 17px;
  width: 600px;
  height: 20px;
}
.greyList-s{
  position: relative;
  margin-left: calc(50% - 560px);
  margin-bottom: 80px;
  width: 1120px;
  height: 54px;
  background: #FFFFFF;
  border-radius: 8px;
}
.greyListText1{
  position: absolute;
  right: 749px;
  top: 17px;
  width:400px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3A3A3A;
  line-height: 20px;
  text-align: right;
}
.gretListLine{
  position: absolute;
  top: 14px;
  left: 400px;
  width: 2px;
  height: 26px;
  background-color:#979797 ;
  opacity: 0.5;
}
.greyListText{
  position: absolute;
  top: 17px;
  left: 430px;
  width: 483px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  line-height: 20px;
}
.greyListText-s{
  position: relative;
  margin-top: 13px;
  margin-bottom: 20px;
  margin-left: 422px;
  width: 690px;
  height: 20px;
}
.greyListText-s1{
  position: relative;
  margin-bottom: 20px;
  margin-left: 422px;
  width: 690px;
  height: 20px;
}
.greyListText1-s{
  position: absolute;
  left: 8px;
  width: 280px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #B8B8B8;
  line-height: 20px;
}
.greyListLine{
  position: absolute;
  top: 10px;
  left: 0;
  width: 280px;
  height: 1px;
  background:  #B8B8B8;
}
.greyListText2-s{
  position: absolute;
  left: 330px;
  width: 150px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  line-height: 20px;
}
.keyLine1{
  position: absolute;
  top: 24px;
  left: 0;
  width: 508px;
  height: 1px;
  border-bottom: 1px dashed #979797;
}
.keyLine2{
  position: absolute;
  top: 24px;
  right: 0;
  width: 508px;
  height: 1px;
  border-bottom: 1px dashed #979797;
}
.keyIcon1{
  position: absolute;
  top: 0;
  left: calc(50% - 40px);
  width: 80px;
  height: 48px;
}
.keyIcon2{
  position: absolute;
  top: 19px;
  right: 55px;
  cursor: pointer;
}
.keyIcon3{
  position: absolute;
  top: 19px;
  right: 100px;
  cursor: pointer;
}
.keyIcon_compare{
  position: absolute;
  top: 20px;
  right: 15px;
  cursor: pointer;
}
.keyIcon4{
  position: absolute;
  top: 13px;
  right: 23px;
  cursor: pointer;
}
.keyTitle{
  position: absolute;
  top: 13px;
  left: calc(50% - 60px);
  width: 120px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 22px;
  text-align: center;
}
.countTitle{
  margin-left: calc(50% - 400px);
  margin-top: 50px;
  margin-bottom: 25px;
  width: 800px;
  height: 20px;
  text-align: center;

  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 25px;
}
.countText1{
  margin-left: calc(50% - 400px);
  margin-bottom: 25px;
  width: 800px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #CCCCCC;
  line-height: 20px;
  text-align: center;
}
.countWhite{
  position: relative;
  /* margin-left: calc(50% - 500px); */
  /* margin-bottom: 80px; */
  width: 1000px;
  height: 520px;
  /* background: #FFFFFF; */
  border-radius: 8px;
  color: #FFFFFF;
  /* display: flex;
  justify-content: center;
  align-items: center; */
}
.greyImg{
  position: absolute;
  top: 30px;
  left: 67px;
  width: 41px;
  height: 41px;
  background: #5b5b5b1b;
  border-radius: 50%;
  cursor: pointer;
}
.countIcon1{
  position: absolute;
  top: 41px;
  left: 79px;
  cursor: pointer;
}
.countIcon3{
  position: absolute;
  width: 20px;
  height: 20px;
  top: 5px;
  right: 5px;
  cursor: pointer;
}
.countIcon2{
  position: absolute;
  top: 41px;
  left: 250px;
  cursor: pointer;
}
.countText2{
  position: absolute;
  top: 38px;
  left: 271px;
  width: 90px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 20px;
  text-align: center;
}
.countCalendar{
  position: absolute;
  width: 476px;
  height: 224px;
  top: 103px;
  left: 68px;
}
.countCircle{
  position: relative;
  float: left;
  margin-left: 10px;
  margin-bottom: 11px;
  width: 44px;
  height: 44px;
  cursor: pointer;
}
.countCirclespe1{
  position: relative;
  float: left;
  margin-left: 108px;
  margin-bottom: 11px;
  width: 44px;
  height: 44px;
  cursor: pointer;
}
.countCirclespe2{
  position: relative;
  float: left;
  margin-left: 0px;
  margin-bottom: 11px;
  width: 44px;
  height: 44px;
  cursor: pointer;
}
.countCircle1{
  position: absolute;
  top: 0;
  left: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: transparent;
}
.countCircle2{
  position: absolute;
  top: 4px;
  left: 4px;
  width: 36px;
  height: 36px;
  background-color: rgb(42 42 42);
  border-radius: 50%;
  text-align: center;
  line-height: 36px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF ;
}
.calendarDialog{
  position: absolute;
  width: 400px;
  height: 150px;
  background: #FFFFFF;
  box-shadow: 1px 1px 5px 2px rgba(0,0,0,0.2);
  top: 75px;
  left: 79px;
  z-index: 1;
}
.calendarDialog{
  position: absolute;
  width: 400px;
  height: 150px;
  background: #FFFFFF;
  box-shadow: 1px 1px 5px 2px rgba(0,0,0,0.2);
  top: 75px;
  left: 79px;
  z-index: 1;
}
.calendarYear{
  position: absolute;
  width: 64px;
  height: 30px;
  background: #fff;
  top: 15px;
  left: 100px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  font-family: PingFangSC-Semibold, PingFang SC;
  color: #3A3A3A;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.calendarYear-s{
  position: absolute;
  width: 64px;
  height: 30px;
  background: #fff;
  top: 15px;
  left: 100px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  font-family: PingFangSC-Semibold, PingFang SC;
  color: #49C2FF;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.calendarYear:hover{
  background: #F7F7F7;
}
.calendarMonth{
  position: absolute;
  width: 330px;
  height: 64px;
  top: 65px;
  left: 43px;
}
.calendarMonth1{
  float: left;
  background: #fff;
  margin-right: 15px;
  margin-bottom: 12px;
  width: 40px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
}
.calendarMonth1-s{
  float: left;
  background: #fff;
  margin-right: 15px;
  margin-bottom: 12px;
  width: 40px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #49C2FF;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
}
.calendarMonth1:hover{
  background: #F7F7F7;

}
.totalStatistics{
  position: absolute;
  top: 342px;
  left: 79px;
  width: 480px;
  height: 42px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 22px;
}
.calendarTip{
  position: absolute;
  bottom: 60px;
  left: 79px;
  width: 480px;
  height:auto;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  line-height: 22px;
}
.mkStatistics{
  top: 40px;
  left: 630px;
  position: absolute;
  height: 420px;
  width: 380px;
  overflow-y: auto;
  overflow-x: hidden;
}
.mkNum{
  position: relative;
  width: 500px;
  height: 20px;
  margin-bottom: 20px;
}
.mkNumName{
  position: absolute;
  left: 0;
  top: 0;
  width: 300px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  /* color: #3A3A3A; */
  color: #FFFFFF;
  line-height: 20px;
}
.mkNumCount{
  position: absolute;
  left: 300px;
  width: 100px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  /* color: #777777; */
  color: #979797;
  line-height: 20px;
}
.greyButton{
  margin-left: calc(50% - 75px);
  width: 150px;
  height: 40px;
  background: #1E81EB;
  border-radius: 8px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  margin-bottom: 125px;
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.shadowContent1{
  position: fixed;
  top: calc(50% - 200px);
  left: calc(50% - 400px);
  width: 800px;
  height: 400px;
  background: #FFFFFF;
  border-radius: 12px;
}
.shadowClose{
  position: absolute;
  width: 40px;
  height: 40px;
  top: 0px;
  right: -55px;
  cursor: pointer;
}
.shadowtext1{
  position: absolute;
  top: 50px;
  left: calc(50% - 60px);
  width: 120px;
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 25px;
  text-align: center;
}
.shadowText2{
  position: absolute;
  top: 108px;
  left: 74px;
  width: 660px;
  height: 150px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 30px;
}
.shadowButton{
  position: absolute;
  top: 307px;
  left: calc(50% - 75px);
  width: 150px;
  height: 40px;
  background: #CCCCCC;
  border-radius: 6px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
}
.shadowButton1{
  position: absolute;
  top: 307px;
  left: calc(50% - 75px);
  width: 150px;
  height: 40px;
  background: #0066CC;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
}

::v-deep .mapDialog{
  overflow-y: unset;
  z-index: 1001;
}
::v-deep .theme--light.v-card{
  background: rgba(238,238,238);
}
</style>

<style lang="scss" scoped>

// 滚动条宽度
div::-webkit-scrollbar{
  width: 10px;
}
// 滚动条轨道
div::-webkit-scrollbar-track{
  background: rgb(239, 239, 239,0);
  border-radius: 2px;
}
// 小滑块
div::-webkit-scrollbar-thumb{
  background: rgba(76, 76, 76, 0.8);
  border-radius: 10px;
}
div::-webkit-scrollbar-thumb:hover{
  background: rgba(76, 76, 76, 1);
}

::v-deep .ps__thumb-y{
  cursor: pointer;
}
::v-deep .ps .ps__rail-x:hover,
::v-deep .ps .ps__rail-y:hover,
::v-deep .ps .ps__rail-x:focus,
::v-deep .ps .ps__rail-y:focus,
::v-deep .ps .ps__rail-x.ps--clicking,
::v-deep .ps .ps__rail-y.ps--clicking {
  background-color: unset;
  opacity: 0.9;
}
</style>

<style lang="scss" scoped>
.fast_btn {
  // width: 128px;
  margin: 0 auto;
  padding-left: 0px;
  .content_btn {
    width: 128px;
    height: 44px;
    margin: 0 auto;
    background: linear-gradient(180deg, #229bff 0%, #0071e3 100%);
    border-radius: 27px;
    border: 1px solid transparent;/*消除悬停时一像素错位调动的问题*/
    outline: none;
    color: #ffffff;
    text-align: center;

    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 20px;
  }
  .content_btn_border {
    margin-left: 20px;
    width: 128px;
    height: 44px;
    border-radius: 27px;
    border: 1px solid #ffffff;
    text-align: center;
    color: #ffffff;
    background: rgba(0, 0, 0, 0);//去掉浅蓝色背景的干扰


    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 20px;
  }
}
</style>


<!-- POI -->
<style lang="scss" scoped>
.dfmBtn{
  position: absolute;
  top: 18px;
  left: 210px;
  color: white;
}
::v-deep .dfmBtnDiv{
  cursor: pointer;
  position: absolute;
  // top: 25px;
  top: 13px;
  left: 235px;
  // border: #a4a4a4 1px solid;
  border-radius: 4px;
  width: 30px;
  height: 30px;
  background-color: rgba(42 42 42);
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .dfmAllDiv{
  position:absolute;
  display:flex;
  align-items:center;
  width:500px;
  z-index:999;
  // top:25px;
  top:13px;
  left: 25px;
}
::v-deep .sjzBtnDiv{
  cursor: pointer;
  margin-left: 10px;
  // border: #a4a4a4 1px solid;
  border-radius: 4px;
  width: 30px;
  height: 30px;
  background-color: rgba(42 42 42);
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .searchBar{
  position: absolute;
  width: 200px;
  // top: 25px;
  top: 13px;
  left: 25px;
  background: #2A2A2A;
}
.searchList{
  position: absolute;
  min-width: 424px;
  top: 65px;
  left: -10px;
  box-shadow: 0px 0px 5px 0px rgba(255,255,255,0.2);
  border-radius: 8px;
}
// ::v-deep .ant-list-items{
.searchListItem{
  background: #2A2A2A;
  div{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 38px;
    color:white;
    a{
      font-size:14px;
      color:white;
    }
    span{
      font-size:12px;
      margin-left:30px;
      color:white;
    }
  }
}
::v-deep .ant-spin-container{
  background: unset;
}
::v-deep .ant-list-item{
  border-bottom: unset !important;
}
::v-deep .anticon,
::v-deep .ant-input-suffix,
::v-deep .ant-input-suffix:hover{
  color:rgb(185, 185, 185);
}
::v-deep .ant-input-clear-icon:hover{
  color:rgb(255, 255, 255);
}
::v-deep .ant-input{
  background: rgba(42 42 42);
  color:rgb(185, 185, 185);
}
::v-deep .ant-input-clear-icon{
  color:rgb(185, 185, 185);
}
::v-deep ul{
  padding-left:unset;
}
.homeStyle{
  left: 524px;
}
.homeBtnStyle{
  left: 730px;
}
.homeBtnTenStyle{
  left: 1030px;
}

.split-source-row {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}
.split-mk-name-wrap {
  position: relative;
  display: inline-block;
  vertical-align: top;

  ::v-deep .ant-select-disabled .ant-select-selection {
    background: #3a3a3a !important;
    border: 1px solid #b9b9b9 !important;
    border-top-width: 1.02px;
    color: rgba(185, 185, 185, 0.9);
    cursor: not-allowed;
    opacity: 1;
  }
  ::v-deep .ant-select-disabled .ant-select-selection__placeholder {
    color: rgba(185, 185, 185, 0.55);
  }
  ::v-deep .ant-select-disabled .ant-select-arrow {
    color: #b9b9b9;
  }

  /* 收起后选中框只显示名称：选项模板里的箭头仍会被渲染进 selection，在此隐藏；下拉层在 body 下不受影响 */
  ::v-deep .ant-select-selection .split-mk-opt-arrow {
    display: none !important;
  }
  ::v-deep .ant-select-selection .split-mk-opt-row {
    display: block;
  }
  ::v-deep .ant-select-selection .split-mk-opt-name {
    display: block;
    width: 100%;
    max-width: 100%;
  }
}
.split-mk-opt-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.split-mk-opt-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.split-mk-opt-arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  min-height: 32px;
  margin: -8px -10px -8px 4px;
  padding: 0 6px;
  flex-shrink: 0;
  box-sizing: border-box;
  cursor: pointer;
}
.split-mk-opt-arrow::before {
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 0 5px 7px;
  border-color: transparent transparent transparent rgba(255, 255, 255, 0.88);
}
.split-mk-detail-panel {
  min-width: 300px;
  max-width: 360px;
  max-height: 280px;
  overflow-y: auto;
  background: #2a2a2a;
  border: 1px solid #979797;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.45);
  padding: 4px 0;
}
.split-mk-detail-row {
  padding: 8px 12px;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  line-height: 1.4;
}
.split-mk-detail-row:hover {
  background: rgba(255, 255, 255, 0.12);
}
.split-mk-detail-row.is-child {
  padding-left: 2em;
  color: rgba(255, 255, 255, 0.92);
}
.split-mk-detail-loading {
  padding: 12px 16px;
  color: #979797;
  font-size: 14px;
}
</style>

<style lang="scss">
/* 挂载在 body 的下拉层，需非 scoped */
.img-split-mk-dropdown.ant-select-dropdown {
  background: #2a2a2a !important;
  border: 1px solid #979797;
}
.img-split-mk-dropdown .ant-select-dropdown-menu-item {
  color: #ffffff !important;
  font-size: 14px;
}
.img-split-mk-dropdown .ant-select-dropdown-menu-item:hover {
  background: rgba(255, 255, 255, 0.12) !important;
}
.img-split-mk-dropdown .ant-select-dropdown-menu-item-selected {
  background: rgba(255, 255, 255, 0.08) !important;
}
.img-split-mk-dropdown .ant-select-dropdown-menu-item-active {
  background: rgba(255, 255, 255, 0.12) !important;
}

/* 图源名称下拉：整行可点，避免点到 menu-item 空白处误触发 document 关闭二级菜单 */
.img-split-mk-series-dropdown.ant-select-dropdown .ant-select-dropdown-menu-item {
  padding: 0 !important;
}
.img-split-mk-series-dropdown.ant-select-dropdown .split-mk-opt-row {
  padding: 8px 12px;
  min-height: 32px;
  width: 100%;
  box-sizing: border-box;
}

/* 图源名称下拉列表滚动条：轨道透明，滑块 #3a3a3a */
.img-split-mk-series-dropdown.ant-select-dropdown .ant-select-dropdown-menu {
  scrollbar-width: thin;
  scrollbar-color: #3a3a3a transparent;
}
.img-split-mk-series-dropdown.ant-select-dropdown .ant-select-dropdown-menu::-webkit-scrollbar {
  width: 6px;
}
.img-split-mk-series-dropdown.ant-select-dropdown .ant-select-dropdown-menu::-webkit-scrollbar-track {
  background: transparent;
}
.img-split-mk-series-dropdown.ant-select-dropdown .ant-select-dropdown-menu::-webkit-scrollbar-thumb {
  background: #3a3a3a;
  border-radius: 3px;
}
</style>

<!-- 认证弹窗样式 -->
<style scoped>
.shadow{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000001;
    background: rgba(0,0,0,0.4);
}
.shadowWhite{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 776px;
    height: 428px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #979797;
}
.shadowClose{
    position: absolute;
    top: 28px;
    right: 40px;
    width: 20px;
    z-index: 1;
    font-size: 32px;
    color: #000000;
    cursor: pointer;
}
.shadowText1{
    position: absolute;
    top: 32px;
    width: 100%;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 32px;
    text-align: center;
}
.shadowText2{
    position: absolute;
    top: 88px;
    left: 64px;
    width: 648px;
    height: 64px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0,0,0,0.65);
    line-height: 32px;
}
.shadowSel{
    position: absolute;
    top: 192px;
    left: 100px;
    width: 276px;
    height: 157px;
    cursor: pointer;
    background: rgba(0,0,0,0.4);
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 10px;
    overflow: hidden;
}
.shadowSel:hover{
    border: 2px solid #1890FF;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 10px;
}
.purchaseAuthLetterDialog{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 560px;
    max-width: 92vw;
    box-sizing: border-box;
    padding: 48px 40px 32px;
    background: #FFFFFF;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.12);
}
.purchaseAuthLetterClose{
    position: absolute;
    top: 20px;
    right: 24px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    z-index: 1;
}
.purchaseAuthLetterTitle{
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: rgba(0,0,0,0.85);
    line-height: 28px;
    margin-bottom: 16px;
}
.purchaseAuthLetterIntro{
    font-size: 14px;
    line-height: 22px;
    color: rgba(0,0,0,0.65);
    text-align: center;
    margin-bottom: 20px;
}
.purchaseAuthLetterRejectLine{
    margin-top: 8px;
    color: rgba(0,0,0,0.65);
}
.purchaseAuthLetterDrop{
    position: relative;
    border: 1px dashed #D9D9D9;
    border-radius: 8px;
    padding: 28px 16px;
    text-align: center;
    cursor: pointer;
    background: #FAFAFA;
    transition: border-color 0.2s, background 0.2s;
}
.purchaseAuthLetterDropActive{
    border-color: #409EFF;
    background: #f0f7ff;
}
.purchaseAuthLetterDropIcon{
    margin-bottom: 12px;
}
.purchaseAuthLetterDropMain{
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    margin-bottom: 8px;
}
.purchaseAuthLetterDropSub{
    font-size: 12px;
    color: rgba(0,0,0,0.45);
}
.purchaseAuthLetterFileInput{
    display: none;
}
.purchaseAuthLetterFileRow{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 12px;
    font-size: 14px;
    color: #409EFF;
}
.purchaseAuthLetterFileName{
    text-decoration: underline;
    max-width: 380px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.purchaseAuthLetterFileRemove{
    cursor: pointer;
    color: rgba(0,0,0,0.45);
    font-size: 18px;
    line-height: 1;
    text-decoration: none;
}
.purchaseAuthLetterTemplateLink{
    display: block;
    text-align: center;
    margin-top: 16px;
    font-size: 14px;
    color: #409EFF;
    text-decoration: underline;
    cursor: pointer;
}
.purchaseAuthLetterFooter{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    margin-top: 28px;
}
.purchaseAuthLetterBtnPrimary{
    min-width: 120px;
    padding: 0 24px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #409EFF;
    color: #fff;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
}
.purchaseAuthLetterBtnPrimary:hover{
    background: #66b1ff;
}
.purchaseAuthLetterBtnGhost{
    min-width: 120px;
    padding: 0 24px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #fff;
    color: rgba(0,0,0,0.85);
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
}
.purchaseAuthLetterBtnGhost:hover{
    border-color: #409EFF;
    color: #409EFF;
}
.authLetterLayer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000002;
    pointer-events: auto;
}
.authLetterTopTip {
    position: absolute;
    top: 20px;
    left: 16px;
    right: 16px;
    z-index: 2;
    text-align: center;
    box-sizing: border-box;
    pointer-events: none;
}
.authLetterTopTipInner {
    display: inline-flex;
    align-items: flex-start;
    gap: 8px;
    max-width: 90%;
    padding: 10px 16px;
    border-radius: 4px;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.12);
    pointer-events: auto;
    text-align: left;
}
.authLetterTopTipInner--success {
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    color: rgba(0,0,0,0.88);
}
.authLetterTopTipInner--error {
    background: #fff2f0;
    border: 1px solid #ffccc7;
    color: rgba(0,0,0,0.88);
}
.authLetterTopTipText {
    line-height: 1.4;
    word-break: break-word;
}
.authLetterTopTipMark {
    flex-shrink: 0;
    font-weight: 700;
    line-height: 1.2;
}
.authLetterTopTipInner--success .authLetterTopTipMark {
    color: #52c41a;
}
.authLetterTopTipInner--error .authLetterTopTipMark {
    color: #ff4d4f;
}
.authLetterShadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(0,0,0,0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    box-sizing: border-box;
}
.authLetterModal {
    position: relative;
    width: 600px;
    max-width: 100%;
    max-height: 90vh;
    overflow: auto;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.12);
    padding: 28px 32px 32px;
    box-sizing: border-box;
}
.authLetterClose {
    position: absolute;
    top: 20px;
    right: 24px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    z-index: 1;
}
.authLetterTitle {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: rgba(0,0,0,0.88);
    margin-bottom: 16px;
    padding-right: 32px;
}
.authLetterDesc {
    text-align: center;
    font-size: 15px;
    line-height: 1.6;
    color: rgba(0,0,0,0.65);
    margin-bottom: 20px;
}
.authLetterReject {
    text-align: center;
    font-size: 14px;
    line-height: 1.5;
    color: rgba(0,0,0,0.45);
    margin-bottom: 20px;
}
.authLetterDrop {
    border: 1px dashed #c9cdd4;
    background: #fafafa;
    border-radius: 8px;
    padding: 32px 16px 28px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 12px;
    transition: background 0.2s, border-color 0.2s;
}
.authLetterDrop--active {
    background: #f0f7ff;
    border-color: #1E81EB;
}
.authLetterFileInput {
    display: none;
}
.authLetterDropIcon {
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
}
.authLetterDropLine1 {
    font-size: 15px;
    color: rgba(0,0,0,0.88);
    margin-bottom: 8px;
}
.authLetterDropLine2 {
    font-size: 12px;
    color: rgba(0,0,0,0.45);
}
.authLetterFileRow {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(0,0,0,0.45);
    margin-bottom: 4px;
    padding: 0 4px;
}
.authLetterFileClip {
    margin-right: 6px;
    font-size: 14px;
}
.authLetterFileName {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.authLetterFileRemove {
    margin-left: 8px;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
    color: #999;
}
.authLetterFileRemove:hover {
    color: #333;
}
.authLetterBar {
    height: 2px;
    background: #1E81EB;
    border-radius: 1px;
    margin: 0 0 12px 0;
}
.authLetterLink {
    display: block;
    text-align: center;
    color: #1E81EB;
    font-size: 15px;
    margin-bottom: 24px;
    cursor: pointer;
    text-decoration: none;
}
.authLetterLink:hover {
    text-decoration: underline;
}
.authLetterLink--disabled {
    color: #bfbfbf !important;
    cursor: not-allowed;
    pointer-events: none;
}
.authLetterBtns {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 16px;
}
.authLetterBtn1 {
    min-width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #1E81EB;
    color: #fff;
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
    padding: 0 24px;
    border: none;
}
.authLetterBtn1--disabled {
    opacity: 0.55;
    cursor: not-allowed;
}
.authLetterBtn2 {
    min-width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #fff;
    color: rgba(0,0,0,0.45);
    font-size: 16px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
    padding: 0 24px;
}
</style>